const statusPerms = {
  created: "Chargeur",
  submitted: "Vérificateur",
  verified: "Validateur",
  validated: "Authentificateur",
  rejected: "Chargeur",
  authenticated: "Chargeur",
  awaiting_redressing: "Chargeur",
};

const actionPerms = {
  soumettre: "Chargeur",
  verifier: "Vérificateur",
  valider: "Validateur",
  authentifier: "Authentificateur",
  rejeter: "Vérificateur",
  payer: "Chargeur",
};

const cameroon = {
  "@id": "/api/countries/39",
  "@type": "Country",
  id: 39,
  uuid: "503626da-1652-11ef-8bc4-00090ffe0001",
  code: "CM",
  name: "Cameroon",
  region: "/api/regions/4",
};

const portsCamer = [
  {
    "@id": "/api/town_functions/2157",
    "@type": "TownFunction",
    id: 2157,
    uuid: "3a626a6d-1683-11ef-8bc4-00090ffe0001",
    code: "CMKBI",
    name: "Kribi",
    town: "/api/towns/12880",
    function: "Port Maritime",
    countryName: "Cameroon",
    countryCode: "CM",
  },
  {
    "@id": "/api/town_functions/2154",
    "@type": "TownFunction",
    id: 2154,
    uuid: "3a626521-1683-11ef-8bc4-00090ffe0001",
    code: "CMDLA",
    name: "Douala",
    town: "/api/towns/12868",
    function: "Port Maritime",
    countryName: "Cameroon",
    countryCode: "CM",
  },
];

const messages = {
  en: {
    //GENERICS
    alert_file_size:
      "The maximum authorized size is {maxSize} MB, choose another file which is less heavy",
    alert_file_upload_error: "An error occured while uploading file",
    //LANDING PAGE
    landing_page_btn_dashboard: "Dashboard",
    landing_page_btn_connexion_msg: "Login",
    app_name: "BESC 3.0",
    landing_page_besc_intro:
      "The Electronic Cargo Tracking Note, abbreviated to E.C.T.N, covers the statistical, identification, transport cost control, security and traceability needs of trade and traffic of goods coming from, going to or in transit via the Republic of Cameroon.",
    landing_page_acknowledge_procedures:
      "Please read the updated procedures below, or simply contact the CNSC.",
    landing_page_btn_documentation: "Documentation",
    landing_page_btn_costs: "Tarification",
    landing_page_btn_intermediary: "Intermediaries",
    landing_page_stay_connected: "Stay tuned",
    landing_page_follow_us: "Follow us on social media to stay updated.",
    landing_page_newsletter_updates: "Newsletter updates",
    landing_page_newsletter_subscribe:
      "Subscribe to our newsletter to stay updated on our procedures.",
    landing_page_anti_spam:
      "We promise not to spam your inbox. We also hate spam!",
    landing_page_btn_newsletter_subscribe: "Subscribe",
    landing_page_company_name: "Cameroon National Shippers Council",

    //PAGES REGISTER
    //LOGIN PAGE
    login_page_existing_account: "Existing account",
    login_page_you_have_account: "You already have an account? Please login",
    login_page_label_email: "Email adress",
    login_page_label_password: "Password",
    login_page_remember_me: "Remember me",
    login_page_btn_login: "Login",
    login_page_forgot_password: "Forgot password?",
    login_page_back_home: "Home",
    login_page_title: "Login Page",
    login_page_company: "Cameroon National Shippers Council",
    login_page_activity: "ECTN delivery for Cameroon",
    login_page_create_account: "Create an account",
    login_page_login: "Login",

    //FORGOT PASSWORD PAGE
    forgot_password_page_title: "Recover your password",
    forgot_password_page_description:
      "Enter your e-mail address and we shall send a verification code to reset your password",
    forgot_password_page_step_label_1: "Reset your password",
    forgot_password_page_step_label_2: "Code verification",
    forgot_password_page_step_label_else: "Change password",
    forgot_password_page_robot_verification: "Robot verification is required",
    forgot_password_page_email_required: "E-mail address is required",
    forgot_password_page_invalid_email: "Invalid e-mail address",
    forgot_password_page_verification_code_required:
      "Verification code is required",
    forgot_password_page_different_passwords: "The two passwords are different",
    forgot_password_page_btn_back: "Back",
    forgot_password_page_placeholder_enter_code: "Enter the verification code",
    forgot_password_page_label_password: "Password",
    forgot_password_page_tooltip_hide_password: "Hide password",
    forgot_password_page_tooltip_show_password: "Show password",

    forgot_password_page_label_confirm_password: "Confirmer le mot de passe",
    forgot_password_page_btn_resend_code: "Renvoyez le code",
    forgot_password_page_message_attention: "Attention!",
    forgot_password_page_msg_processing: "Traitement en cours...",
    //REGISTER PAGE
    register_page_title: "Registration Page",
    register_page_company: "Company",
    register_page_main_account: "Main Account",
    register_page_label_country: "Country",
    register_page_label_niu: "Taxpayer Number",
    register_page_label_category: "Category",
    register_page_label_category_person: "Natural Person",
    register_page_label_category_company: "Company",
    register_page_label_company_name: "Company Name",
    register_page_label_telephone: "Telephone",
    register_page_label_email: "Email Adress",
    register_page_label_representative: "Legal Representative",
    register_page_label_document: "Taxpayer Document",
    register_page_label_document_nic: "National ID / Passport document",
    register_page_label_designation_letter_document: "Designation Letter",
    register_page_label_nic: "Identity Document",
    register_page_btn_back: "Back",
    register_page_btn_next: "Next",
    register_page_btn_create_account: "Create an account",
    register_page_label_name: "Name",
    register_page_label_surname: "Surname",
    register_page_label_main_telephone: "Telephone",
    register_page_label_main_email: "Email adress",
    register_page_label_password: "Password",
    register_page_label_repeat_password: "Repeat password",
    register_page_label_password_strength: "Password strength : ",
    register_page_label_password_requirements:
      "Password must contain at least 8 characters: at least one lowercase and one uppercase letter, one special character and one number",
    register_page_label_password_strength_weak: "Weak",
    register_page_label_password_strength_medium: "Medium",
    register_page_label_password_strength_strong: "Strong",
    register_page_typo_accept_conditions: "Accept the terms of use",

    register_page_tooltip_download_template: "Download Template",

    resgister_page_dialog_terms_title: "Terms of use",
    resgister_page_dialog_terms_description:
      "Read carefully the terms of use below before you proceed",
    resgister_page_dialog_terms_button_accept: "Accept",
    resgister_page_dialog_terms_button_close: "Close",

    //DASHBOARD SHIPPER
    //PAGE TITLE
    dashboard_shipper_page_title: "Shipper Dashboard",
    dashboard_shipper_page_description:
      "Overview displaying the different statistics of the BESCs created.",
    //PAGE COMPONENT
    card_title_besc_submitted:
      "{itemCount, plural, =0 { ECTN submitted} one { ECTN submitted} other { ECTNs submitted}}",
    card_title_besc_processing:
      "{itemCount, plural, =0 { ECTN being processed} one { ECTN being processed} other { ECTNs being processed}}",
    card_title_besc_authenticated:
      "{itemCount, plural, =0 { ECTN authenticated} one { ECTN authenticated} other { ECTNs authenticated}}",
    card_title_besc_rejected:
      "{itemCount, plural, =0 { ECTN rejected} one { ECTN rejected} other { ECTNs rejected}}",

    //BILLING
    //FORMULAIRE MOUVEMENT MANUEL
    //PAGE TITLE
    page_mouvement_manuel_title: "Manual account debit/credit form",
    page_mouvement_manuel_description:
      "Form to manually debit or credit an account by entering the information and the reason for the transaction",
    //PAGE CONTENT
    page_mouvement_manuel_card_title: "Debit or credit account",
    page_mouvement_manuel_card_table_title: "List of debit/credit requests",
    page_mouvement_manuel_label_explication: "Explanation",
    page_mouvement_manuel_dialog_validate_description:
      "Please confirm the amount to debit/credit on the account",

    //FORMULAIRE DEMANDE D'APPROVISIONNEMENT
    //PAGE TITLE
    dialog_demande_approvisionnement_title: "Credit Account Funding Terms",
    page_demande_approvisionnement_title: "Funding request form",
    page_demande_approvisionnement_description:
      "Form to request funding of an account by filling in the requested information",
    //PAGE CONTENT
    page_demande_approvisionnement_funding_terms_error:
      "You much accept terms by typing YES before you can continue this operation",
    page_demande_approvisionnement_card_response: "Response",
    page_demande_approvisionnement_card_validate: "Confirm",
    page_demande_approvisionnement_card_title: "Fund your account",
    page_demande_approvisionnement_label_payment_mode: "Means of payment",
    page_demande_approvisionnement_label_amount: "Amount",
    page_demande_approvisionnement_label_phone: "Phone Number",
    page_demande_approvisionnement_label_bank: "Bank",
    page_demande_approvisionnement_btn_submit: "Submit request",
    page_demande_approvisionnement_notify_saving:
      "Saving of the request in progress...",
    page_demande_approvisionnement_notify_success:
      "Funding successfully initiated, you can download the proforma to proceed with payment and validation",
    page_demande_approvisionnement_alert_initiating_momo:
      "Initiating MoMo payment...",
    page_demande_approvisionnement_alert_initiating_om:
      "Initiating OM payment...",
    page_demande_approvisionnement_alert_initiating_axepta:
      "Initiating Afriland payment...",
    page_demande_approvisionnement_helper_tel:
      "Please enter a valid phone number",
    page_demande_approvisionnement_company_not_found:
      "Company information not found. Please log out and log back in, then try this operation again.",
    page_demande_approvisionnement_company_inactive:
      "Company account not activated. Please contact support team!",
    page_demande_approvisionnement_notify_fill_all_fields:
      "Please select the payment method and specify the amount to be funded.",
    page_demande_approvisionnement_notify_phone_required:
      "Phone number is required",
    page_demande_approvisionnement_notify_error_crediting:
      "An error occurred during your funding request, please try again.",

    //LISTING DES REDRESSEMENTS BESC
    //PAGE TITLE
    page_listing_redressement_title: "List of all ECTN redressings",
    page_listing_redressement_description:
      "Table displaying the list of all paid and unpaid ECTN redressings",

    //LISTING DES DEMANDES D'APPROVISIONNEMENT
    //PAGE TITLE
    page_listing_approvisionnements_title:
      "List of funding requests made by the user",
    page_listing_approvisionnements_description:
      "Table displaying the various funding requests recorded in the system",

    //TOOLTIPS
    page_listing_approvisionnements_tooltip_clear: "Erase",
    page_listing_approvisionnements_tooltip_refresh: "Refresh",
    page_listing_approvisionnements_tooltip_download:
      "Download proforma/receipt",
    page_listing_approvisionnements_tooltip_proof: "Download proof of payment",
    page_listing_approvisionnements_tooltip_upload: "Attach proof of payment",
    page_listing_approvisionnements_tooltip_process: "Process",
    page_listing_approvisionnements_tooltip_show: "Show",

    //PAGE CONTENT
    page_listing_approvisionnements_label_search_by: "Search by",
    page_listing_approvisionnements_head_cell_reference: "Reference",
    page_listing_approvisionnements_head_cell_ectn: "ECTN",
    page_listing_approvisionnements_head_cell_company: "Company",
    page_listing_approvisionnements_head_cell_amount_requested:
      "Requested Amount",
    page_listing_approvisionnements_head_cell_date_requested: "Date of request",
    page_listing_approvisionnements_head_cell_amount_received:
      "Received Amount",
    page_listing_approvisionnements_head_cell_status: "Status",
    page_listing_approvisionnements_head_cell_actions: "Actions",
    page_listing_approvisionnements_search_placeholder:
      "Enter a keyword to search...",
    page_listing_approvisionnements_dialog_validate_title:
      "Process the funding request",
    page_listing_approvisionnements_dialog_validate_description:
      "Please attach the file for proof of payment and confirm the amount to be credited to the account",
    page_listing_approvisionnements_dialog_pay_title: "Process payment",
    page_listing_approvisionnements_dialog_pay_description:
      "Fill in the information to complete the payment",
    page_listing_approvisionnements_dialog_validate_label_payment_mode:
      "Means of payment",
    page_listing_approvisionnements_dialog_validate_label_payment_bank:
      "Bank of Payment",
    page_listing_approvisionnements_dialog_validate_label_amount:
      "Expected amount",
    page_listing_approvisionnements_dialog_validate_label_payment_amount:
      "Received amount",
    page_listing_approvisionnements_dialog_validate_label_proof:
      "Proof of payment",
    page_listing_approvisionnements_dialog_validate_label_observation:
      "Observation",
    page_listing_approvisionnements_dialog_validate_btn_cancel: "Cancel",
    page_listing_approvisionnements_dialog_validate_btn_reject: "Reject",
    page_listing_approvisionnements_dialog_validate_btn_validate: "Validate",
    page_listing_approvisionnements_dialog_validate_btn_pay: "Confirm",
    page_listing_approvisionnements_dialog_show_title:
      "Details for transaction",
    page_listing_approvisionnements_dialog_show_description: "Status : ",
    page_listing_approvisionnements_dialog_show_status_approved: "Approved",
    page_listing_approvisionnements_dialog_show_status_waiting:
      "Waiting for verification",
    page_listing_approvisionnements_dialog_show_status_rejected: "Rejected",
    page_listing_approvisionnements_dialog_show_label_payment_mode:
      "Means of payment",
    page_listing_approvisionnements_dialog_show_label_amount_requested:
      "Requested amount",
    page_listing_approvisionnements_dialog_show_label_amount_received:
      "Received amount",
    page_listing_approvisionnements_dialog_show_label_amount_debited:
      "Debited amount",
    page_listing_approvisionnements_dialog_show_label_date_requested:
      "Date of request",
    page_listing_approvisionnements_dialog_show_label_payment_date:
      "Date of payment",
    page_listing_approvisionnements_dialog_show_label_currency: "Currency",
    page_listing_approvisionnements_dialog_show_label_observation:
      "Observation",
    page_listing_approvisionnements_dialog_show_btn_show_payment_proof:
      "Show proof of payment",
    page_listing_approvisionnements_dialog_show_btn_close: "Close",

    page_listing_approvisionnements_dialog_attach_title:
      "Attach proof of payment",
    page_listing_approvisionnements_dialog_attach_description:
      "Please select the file to attach, then click on submit",
    page_listing_approvisionnements_dialog_label_file: "Proof of payment",
    page_listing_approvisionnements_dialog_button_cancel: "Cancel",
    page_listing_approvisionnements_dialog_button_submit: "Submit",
    //HEADER

    //HEADER MENU
    header_menu_home_page: "Home Page",
    //HEADER DOTS
    header_dots_notifications_title: "Notifications",
    header_dots_notifications_description:
      "{itemCount, plural, =0 {You have no new notification} one {You have a new notification} other {You have {itemCount, number} new notifications}}",
    header_dots_tab_notifications: "Notifications",
    header_dots_tab_notifications_no_message: "No unread message",
    header_dots_tab_notifications_btn_see_all: "See all",
    header_dots_tab_notifications_btn_mark_as_read: "Mark as read",
    header_dots_tab_history: "History",
    header_dots_profile_my_account: "My account",
    header_dots_profile_settings: "Settings",
    header_dots_profile_tasks: "Tasks",
    header_dots_profile_balance: "Account Balance",
    header_dots_profile_amount_engaged: "Amount committed",
    header_dots_btn_logout: "Logout",

    //PROFILE PAGE
    //PAGE TITLE
    profile_page_title: "Profile",
    profile_page_content:
      "View of the user profile with the possibility of changing some information",
    //PAGE CONTENT
    profile_page_btn_change_photo: "Change picture",
    profile_page_label_sub_accounts: "Sub accounts",
    profile_page_tab_profile_details: "Profile Details",
    profile_page_tab_profile_details_title: "Account Details",
    profile_page_tab_profile_details_label_name: "Name",
    profile_page_tab_profile_details_label_surname: "Surname",
    profile_page_tab_profile_details_label_email: "E-mail",
    profile_page_tab_profile_details_label_nic: "NIC",
    profile_page_tab_profile_details_label_function: "Function",
    profile_page_tab_profile_details_label_phone: "Phone",
    profile_page_tab_profile_details_btn_submit: "Submit",
    profile_page_tab_profile_details_btn_processing: "Processing...",
    profile_page_tab_company_details: "Company Details",
    profile_page_tab_company_details_title: "Company Details",
    profile_page_tab_company_details_label_company_name: "Company Name",
    profile_page_tab_company_details_label_taxpayer_number: "Taxpayer Number",
    profile_page_tab_company_details_label_currency: "Currency",
    profile_page_tab_company_details_label_country: "Country",
    profile_page_tab_company_details_label_representative: "Representative",
    profile_page_tab_company_details_label_phone: "Phone",
    profile_page_tab_company_details_label_email: "E-mail",
    profile_page_tab_company_details_label_language: "Preferred Language",
    profile_page_tab_company_details_btn_become_intermediary:
      "Become an intermediary",
    profile_page_tab_company_details_btn_submit: "Submit",

    profile_page_tab_security: "Security",
    profile_page_tab_security_title: "Change password",
    profile_page_tab_security_label_password: "Old password",
    profile_page_tab_security_label_new_password: "New password",
    profile_page_tab_security_label_confirm_password: "Repeat new password",
    profile_page_tab_security_btn_submit: "Apply",

    profile_page_tab_company_become_intermediary_processing_information:
      "Your request to become an intermediary is in progress. You will be notified by mail the status of the request",

    profile_page_alert_success: "Success",
    profile_page_alert_error: "Error",

    //PAGE DE CREATION
    //PAGE TTTLE
    create_besc_maritime_import_page_title_create: "New {sense} Import ECTN",
    create_besc_maritime_import_page_title_edit: "Editing the ECTN {number}",
    create_besc_maritime_import_page_description_create:
      "Form for creating an ECTN by filling in the different fields",
    create_besc_maritime_import_page_description_edit:
      "Form for editing an ECTN by updating the various fields",

    //PAGE CONTENT
    create_besc_has_reference: "Do you have a reference number?",
    create_besc_is_grouped: "Is it a grouping?",
    create_besc_label_reference: "Reference number",
    create_besc_maritime_import_notify_creating_shipper:
      "Adding new shipper...",
    create_besc_maritime_import_notify_success_shipper:
      "Shipper added successfully",
    create_besc_maritime_import_notify_creating_foreign_shipper:
      "Adding new foreign shipper...",
    create_besc_maritime_import_notify_success_foreign_shipper:
      "Foreign shipper added successfully",
    //SECTION FICHIERS
    create_besc_maritime_import_accordion_files: "Files",
    create_besc_maritime_import_accordion_files_typo_file_type: "File type",
    create_besc_maritime_import_accordion_files_typo_load_file: "Load a file",
    create_besc_maritime_import_accordion_files_typo_file_name: "File name",
    create_besc_maritime_import_accordion_files_select_ref:
      "Reference document",
    create_besc_maritime_import_accordion_files_select_commercial:
      "Commercial invoice",
    create_besc_maritime_import_accordion_files_select_fret: "Freight invoice",
    create_besc_maritime_import_accordion_files_select_packing_list:
      "Packing list",
    create_besc_maritime_import_accordion_files_select_packing_certificate:
      "Packing certificate",
    create_besc_maritime_import_accordion_files_select_certificate_origin:
      "Certificate of origin",
    create_besc_maritime_import_accordion_files_special_authorization:
      "FIMEX/ASI",
    create_besc_maritime_import_accordion_files_exoneration:
      "Exoneration document",
    create_besc_maritime_import_accordion_files_select_vgm: "VGM Certificate",
    create_besc_maritime_import_accordion_files_select_other: "Other",
    create_besc_maritime_import_accordion_files_btn_add: "Add a file",
    create_besc_maritime_import_accordion_files_alert_file_size:
      "The maximum authorized size is 2MB, choose another file which is less heavy",
    create_besc_maritime_import_accordion_files_alert_fill_special_authorization:
      "Please upload the FIMEX/ASI document to proceed",
    create_besc_maritime_import_accordion_files_alert_fill_packing_certificate:
      "Please upload the packing certificate document to proceed",
    create_besc_maritime_import_accordion_files_alert_fill_vgm:
      "Please upload the VGM certificate document to proceed",

    //SECTION SUIVI
    create_besc_maritime_import_accordion_transaction: "Transaction",
    create_besc_maritime_import_accordion_transaction_title: "Transaction",
    create_besc_maritime_import_accordion_transaction_dialog_title:
      "Add a transaction",
    create_besc_maritime_import_accordion_transaction_dialog_description:
      "You have a transaction number? Enter it here",
    create_besc_maritime_import_accordion_transaction_dialog_label_transaction:
      "Transaction number",
    create_besc_maritime_import_accordion_transaction_dialog_label_taxpayer_number:
      "Taxpayer number",
    create_besc_maritime_import_accordion_transaction_dialog_btn_cancel:
      "Cancel",
    create_besc_maritime_import_accordion_transaction_dialog_btn_add: "Add",
    create_besc_maritime_import_accordion_transaction_dialog_notify_searching:
      "Searching transaction...",
    create_besc_maritime_import_accordion_transaction_dialog_notify_added:
      "Transaction added successfully!",
    create_besc_maritime_import_accordion_transaction_dialog_notify_different_shipper:
      "This transaction number has information on a different shipper than the one filled in the form",
    create_besc_maritime_import_accordion_transaction_dialog_notify_not_found:
      "Cannot find transaction",
    create_besc_maritime_import_accordion_transaction_dialog_helper_transaction:
      "Transaction already added",

    //SECTION EXPEDITEUR&DESTINATAIRE
    create_besc_maritime_import_accordion_shippers: "Sender & Recipient",
    //DESTINATAIRE
    create_besc_maritime_import_accordion_shippers_card_recipient: "Recipient",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_name:
      "Name",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_taxpayer_number:
      "Taxpayer Number",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_phone:
      "Phone",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_email:
      "E-mail",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_address:
      "Address",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_town:
      "Town",
    create_besc_maritime_import_accordion_shippers_card_recipient_helper_existing_taxpayer_number:
      "This taxpayer number is already present in the system",
    create_besc_maritime_import_accordion_shippers_card_recipient_helper_blocked_shipper:
      "ECTN creation is currently disabled for this shipper",
    create_besc_maritime_import_accordion_shippers_card_recipient_helper_invalid_phone:
      "Please enter a valid phone number",
    create_besc_maritime_import_accordion_shippers_card_recipient_helper_invalid_taxpayer_number:
      "Please enter a valid taxpayer number",
    create_besc_maritime_import_accordion_shippers_card_recipient_helper_invalid_email:
      "Please enter a valid email",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_searching:
      "Searching...",
    //EXPEDITEUR
    create_besc_maritime_import_accordion_shippers_card_sender: "Sender",
    create_besc_maritime_import_accordion_shippers_card_sender_label_name:
      "Name",
    create_besc_maritime_import_accordion_shippers_card_sender_label_phone:
      "Phone",
    create_besc_maritime_import_accordion_shippers_card_sender_label_email:
      "E-mail",
    create_besc_maritime_import_accordion_shippers_card_sender_label_address:
      "Address",
    create_besc_maritime_import_accordion_shippers_card_sender_label_town:
      "Town",
    create_besc_maritime_import_accordion_shippers_card_sender_helper_invalid_phone:
      "Please enter a valid phone number",
    create_besc_maritime_import_accordion_shippers_card_sender_helper_invalid_email:
      "Please enter a valid email",
    create_besc_maritime_import_accordion_shippers_card_sender_label_searching:
      "Searching...",

    //SECTION CARGAISON
    create_besc_maritime_import_accordion_cargo: "Cargo",
    create_besc_maritime_import_accordion_cargo_card_cargo: "Cargo Information",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning:
      "Conditionning",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_container:
      "Container",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_roro:
      "Ro-Ro",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_bulk:
      "Bulk",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_conventional:
      "Conventional",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_commercial_value:
      "Invoice Value",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_commercial_currency:
      "Currency",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_fob_value:
      "Fob Value",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_fob_currency:
      "Currency",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product_type:
      "Product Type",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_weight:
      "Weight (Kg)",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_volume:
      "Volume in",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_twenty:
      "Nb 20''",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_forty:
      "Nb 40''",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_vehicles:
      "Nb vehicles",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_motos:
      "Nb motos",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_sh_code:
      "SH Codes of the cargo",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_packages:
      "Nb packages",
    create_besc_maritime_import_accordion_cargo_card_cargo_typo_sh_code:
      "SH Code ",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product:
      "Product Name",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product_weight:
      "Weight (Kg)",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product_volume:
      "Volume",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product_value:
      "Value",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product_currency:
      "Currency",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_searching:
      "Searching...",
    //CONTAINER INFORMATION
    create_besc_maritime_import_accordion_cargo_card_container:
      "Container Information",
    create_besc_maritime_import_accordion_cargo_card_container_label_number:
      "Container Number",
    create_besc_maritime_import_accordion_cargo_card_container_label_size:
      "Size",
    create_besc_maritime_import_accordion_cargo_card_container_label_seal:
      "Seal Number",
    create_besc_maritime_import_accordion_cargo_card_container_label_type:
      "Type",
    create_besc_maritime_import_accordion_cargo_card_container_label_loading:
      "Loading",
    create_besc_maritime_import_accordion_cargo_card_container_label_weight:
      "Weight",
    create_besc_maritime_import_accordion_cargo_card_container_label_content:
      "Content",
    create_besc_maritime_import_accordion_cargo_card_container_helper_existing_container:
      "This container number has already been entered",
    create_besc_maritime_import_accordion_cargo_card_container_helper_existing_seal:
      "This seal number has already been entered",
    create_besc_maritime_import_accordion_cargo_card_container_helper_invalid_container:
      "Please enter a valid container number",
    create_besc_maritime_import_accordion_cargo_card_container_download_template:
      "Download the Excel template",
    create_besc_maritime_import_accordion_cargo_card_container_import_file:
      "Import containers",
    create_besc_maritime_import_accordion_cargo_card_container_import_help:
      "Enter the containers manually, or download the template, fill it in and import it. The number of 20' and 40' containers is counted from the size column.",
    create_besc_maritime_import_accordion_cargo_card_container_import_success:
      "{twenty} container(s) of 20' and {forty} container(s) of 40' imported.",
    create_besc_maritime_import_accordion_cargo_card_container_import_empty:
      "The file has no 20' or 40' container rows.",
    create_besc_maritime_import_accordion_cargo_card_container_import_invalid:
      "Please choose an Excel file (.xlsx).",
    create_besc_maritime_import_accordion_cargo_card_container_import_error:
      "The file could not be read.",

    //VEHICLE INFORMATION
    create_besc_maritime_import_accordion_cargo_card_vehicle:
      "Vehicle Information",
    create_besc_maritime_import_accordion_cargo_card_vehicle_label_number:
      "Vehicle Identification Number",
    create_besc_maritime_import_accordion_cargo_card_vehicle_label_model:
      "Model",
    create_besc_maritime_import_accordion_cargo_card_vehicle_label_gray:
      "Card registration document",
    create_besc_maritime_import_accordion_cargo_card_vehicle_label_year:
      "Date of release",
    create_besc_maritime_import_accordion_cargo_card_vehicle_label_content:
      "Content",
    create_besc_maritime_import_accordion_cargo_card_vehicle_helper_existing_number:
      "This number has already been entered",
    create_besc_maritime_import_accordion_cargo_card_vehicle_alert_file_size:
      "The maximum allowed size is 1MB, please choose a different file",
    //SECTION CONTRAT DE TRANSPORT
    create_besc_maritime_import_accordion_transport: "Transport",
    create_besc_maritime_import_accordion_transport_label_bill_of_lading:
      "Bill Of Lading",
    create_besc_maritime_import_accordion_transport_helper_existing_bl:
      "This bill of lading number is already present in the system for another ECTN, please insert another one",
    create_besc_maritime_import_accordion_transport_label_carrier: "Carrier",
    create_besc_maritime_import_accordion_transport_label_vessel: "Vessel",
    create_besc_maritime_import_accordion_transport_label_voyage:
      "Voyage Number",
    create_besc_maritime_import_accordion_transport_label_date_emb:
      "Boarding date",
    create_besc_maritime_import_accordion_transport_label_eta:
      "Estimated date of arrival",
    create_besc_maritime_import_accordion_transport_label_incoterm: "Incoterm",
    create_besc_maritime_import_accordion_transport_label_country_origin:
      "Country of origin",
    create_besc_maritime_import_accordion_transport_label_country_transit:
      "Country of transit",
    create_besc_maritime_import_accordion_transport_label_pays_emb:
      "Country of Loading",
    create_besc_maritime_import_accordion_transport_label_port_emb:
      "Port of Loading",
    create_besc_maritime_import_accordion_transport_label_port_deb:
      "Port of Discharge",
    create_besc_maritime_import_accordion_transport_label_fret: "Freight",
    create_besc_maritime_import_accordion_transport_label_fret_currency:
      "Currency",
    create_besc_maritime_import_accordion_transport_label_insurance:
      "Insurance",
    create_besc_maritime_import_accordion_transport_label_insurance_currency:
      "Currency",
    create_besc_maritime_import_accordion_transport_label_suppl:
      "Extra charges",
    create_besc_maritime_import_accordion_transport_label_suppl_currency:
      "Currency",
    create_besc_maritime_import_accordion_transport_label_baf: "Baf",
    create_besc_maritime_import_accordion_transport_label_baf_currency:
      "Currency",
    create_besc_maritime_import_accordion_transport_label_caf: "Caf",
    create_besc_maritime_import_accordion_transport_label_caf_currency:
      "Currency",
    create_besc_maritime_import_accordion_transport_label_thc: "Thc",
    create_besc_maritime_import_accordion_transport_label_thc_currency:
      "Currency",
    create_besc_maritime_import_accordion_transport_label_final_dest:
      "Final destination",
    create_besc_maritime_import_accordion_transport_helper_existing_imo:
      "This IMO code is already in the system, the associated vessel is : ",
    create_besc_maritime_import_accordion_transport_notify_adding_vessel:
      "Adding new vessel...",
    create_besc_maritime_import_accordion_transport_notify_vessel_added:
      "Vessel added successfully",
    create_besc_maritime_import_accordion_transport_label_searching:
      "Searching...",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_title:
      "Add a new vessel",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_description:
      "Your vessel can't be found in our list? Add it here",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_label_name:
      "Vessel name",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_label_imo:
      "IMO code",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_label_mmsi:
      "MMSI code",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_btn_cancel:
      "Cancel",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_btn_submit:
      "Add",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_btn_choose:
      "Choose this vessel",

    //SECTION GROUPAGE
    create_besc_maritime_import_accordion_grouping: "Grouping",
    create_besc_maritime_import_accordion_grouping_label_bl_number:
      "Sub BL number",
    create_besc_maritime_import_accordion_grouping_label_file_name: "Sub BL",
    //BOUTONS
    create_besc_maritime_import_btn_create: "Create ECTN",
    create_besc_maritime_import_btn_edit: "Edit ECTN",

    //VISUALISATION
    //PAGE TITLE
    show_besc_page_title: "ECTN Vizualisation",
    show_besc_page_description: "ECTN fields details",
    //PAGE CONTENT
    show_besc_typo_demand_number: "Demand Number",
    show_besc_typo_besc_number: "ECTN Number",
    show_besc_typo_status: "Status",
    show_besc_typo_value: "Value",
    show_besc_typo_penalty: "Penalty for late submission",
    show_besc_typo_submission_date: "Submission Date",
    show_besc_typo_reject_reason: "ECTN rejected for the following reason : ",
    show_besc_btn_submit: "Submit",
    show_besc_btn_edit: "Edit",
    show_besc_btn_authenticate: "Authenticate",
    show_besc_btn_verify: "Verify",
    show_besc_btn_validate: "Validate",
    show_besc_btn_reject: "Reject",
    show_besc_btn_pay: "Pay",
    show_besc_btn_pay_redressing: "Pay redressing",
    show_besc_btn_complete: "Complete",
    show_besc_notify_paying_redressing: "Redressing payment in progress...",
    show_besc_notify_paying: "ECTN payment in progress...",
    show_besc_notify_paid_redressing: "Redressing paid successfully",
    show_besc_notify_paid: "ECTN paid successfully",

    show_besc_notify_verifying: "Verification in progress...",
    show_besc_notify_validating_exoneration: "ECTN exoneration in process...",
    show_besc_notify_cancelling_exoneration: "ECTN exoneration cancelling...",
    show_besc_notify_exonerated: "Exoneration processed successfully",
    show_besc_notify_validating_cancellation: "ECTN cancellation in process...",
    show_besc_notify_cancelling_cancellation:
      "ECTN cancellation rejecting in process...",
    show_besc_notify_cancelled: "Cancellation processed successfully",

    show_besc_notify_insufficient_balance:
      "You don't have enought funds, please top-up your account",
    show_besc_notify_network_error:
      "An error occured during the process, please try again later",

    show_besc_action_submit: "Submiting",
    show_besc_action_reject: "Rejection",
    show_besc_action_validate: "Validation",
    show_besc_action_verify: "Verification",
    show_besc_action_authenticate: "Authentication",
    show_besc_notify_action: "ECTN {action} in progress ",

    show_besc_tooltip_download_pdf: "Download PDF",
    show_besc_tooltip_send_notification: "Send a notification",
    show_besc_tooltip_history: "History",
    show_besc_tooltip_download: "Download",
    show_besc_tooltip_archive: "Archive",

    show_besc_dialog_authenticate_title: "ECTN Authentication",
    show_besc_dialog_authenticate_description:
      "Please enter the estimated date of arrival of the vessel",
    show_besc_dialog_authenticate_description_export:
      "Please enter the estimated date of departure of the vessel",
    show_besc_dialog_authenticate_label_eta: "Estimated date of arrival",
    show_besc_dialog_authenticate_label_etd: "Estimated date of departure",
    show_besc_dialog_authenticate_btn_cancel: "Cancel",
    show_besc_dialog_authenticate_btn_authenticate: " Authenticate",

    show_besc_dialog_complete_title: "Complete information on your ECTN",
    show_besc_dialog_complete_description:
      "Please enter the missing information and submit to be able to print your ECTN",
    show_besc_dialog_complete_label_niu: "Taxpayer number",
    show_besc_dialog_complete_label_file: "Special authorization file",
    show_besc_dialog_complete_btn_validate: "Validate",

    show_besc_dialog_history_title: "Changes made",
    show_besc_dialog_history_content: "Below are the changes made on this ECTN",
    show_besc_dialog_history_btn_close: "Fermer",

    show_besc_dialog_notification_title: "Send a notification",
    show_besc_dialog_notification_description:
      "Please enter the subject and body of the message",
    show_besc_dialog_notification_label_besc: "ECTN ",
    show_besc_dialog_notification_label_subject: "Subject",
    show_besc_dialog_notification_label_content: "Content",
    show_besc_dialog_notification_btn_cancel: "Cancel",
    show_besc_dialog_notification_btn_send: "Send",

    show_besc_dialog_reject_title: "ECTN Rejection",
    show_besc_dialog_reject_description:
      "Please enter the reason for rejecting this ECTN",
    show_besc_dialog_reject_label_reason: "Reason",
    show_besc_dialog_reject_btn_cancel: "Cancel",
    show_besc_dialog_reject_btn_send: "Reject",

    show_besc_dialog_confirm_submit_title: "ECTN Submission",
    show_besc_dialog_confirm_submit_description:
      "Are you sure you want to proceed with this action?",
    show_besc_dialog_confirm_submit_action_cancel: "Cancel",
    show_besc_dialog_confirm_submit_action_confirm: "Submit",

    show_besc_typo_code: "Code",
    show_besc_typo_description: "Description",
    show_besc_typo_produit: "Product",

    //CONFIGURATION
    configuration_typo_add_account: "Add an account",
    configuration_typo_edit_account: "Edit an account",
    configuration_label_name: "Name",
    configuration_label_surname: "Surname",
    configuration_label_phone: "Phone",
    configuration_label_email: "E-mail",
    configuration_label_function: "Function",
    configuration_label_role: "Role",
    configuration_btn_save: "Save",
    configuration_btn_edit: "Edit",
    configuration_btn_cancel: "Cancel",
    configuration_typo_list: "List of accounts",
    configuration_header_name: "Name",
    configuration_header_surname: "Surname",
    configuration_header_phone: "Phone",
    configuration_header_email: "E-mail",
    configuration_header_role: "Role",
    configuration_notify_not_logged:
      "You need to be logged in to perform this action",
    configuration_notify_processing: "Processing...",
    configuration_notify_error_processing: "Error processing data",
    configuration_notify_error_loading: "Error loading data",
    configuration_typo_undefined: "Not defined",

    //LISTE BESC

    //PAGE TITLES
    besc_list_my_bescs_title: "ECTN List",
    besc_list_my_bescs_description: "Table showing the list of ECTNs recorded",
    besc_list_all_bescs_title: "List of all ECTNs of the company",
    besc_list_all_bescs_description:
      "Table showing all ECTNs of the company's account and sub accounts",
    besc_list_besc_history_title: "History of {verb} ECTNs",
    besc_list_besc_history_description:
      "Table showing the list of {verb} ECTNs",
    besc_list_besc_history_verb_verified: "verified",
    besc_list_besc_history_verb_validated: "validated",
    besc_list_besc_history_verb_authenticated: "authenticated",
    besc_list_awaiting_redress_title: "List of redressings",
    besc_list_awaiting_redress_description:
      "Table showing all ECTNs which are awaiting redressing",
    besc_list_awaiting_exoneration_title: "List of exonerations",
    besc_list_awaiting_exoneration_description:
      "Table showing all ECTNs which are awaiting exoneration",
    besc_list_awaiting_cancellation_title: "List of cancellations",
    besc_list_awaiting_cancellation_description:
      "Table showing all ECTNs which are awaiting cancellation",

    //PAGE CONTENT
    besc_list_toggle_text_all: "All ECTNs",
    besc_list_toggle_text_my_space: "My Space",
    besc_list_helper_text_all:
      "Toggle this to see all ECNTs that were locked by you",
    besc_list_helper_text_my_space:
      "Deactivate this option to see all ECTNs waiting to be processed",

    besc_list_head_cell_demande: "Demand Number",
    besc_list_head_cell_etat: "Status",
    besc_list_head_cell_numero: "ECTN Number",
    besc_list_head_cell_numero_bl: "BL Number",
    besc_list_head_cell_societe: "Company",
    besc_list_head_cell_valeur: "Value",
    besc_list_head_cell_nom: "Profile",
    besc_list_head_cell_conditionnement: "Conditionning",
    besc_list_head_cell_extra_reference: "Reference",
    besc_list_head_cell_cree: "Created At",
    besc_list_head_cell_validated: "Validated At",
    besc_list_head_cell_paid_at: "Paid At",
    besc_list_head_cell_provenance: "Origin",
    besc_list_head_cell_loading: "Date of Loading",
    besc_list_search_by_demande: "Demand Number",
    besc_list_search_by_numero: "ECTN Number",
    besc_list_search_by_conditionnement: "Conditionning",
    besc_list_search_by_cree: "Created At",
    besc_list_search_by_expediteur: "Sender",
    besc_list_search_by_destinataire: "Recipient",
    besc_list_search_by_bill_of_lading: "BL Number",
    besc_list_search_by_reference_number: "Reference Number",
    besc_list_search_by_container_number: "Container Number",
    besc_list_search_by_chassis_number: "Chassis Number",

    besc_list_notify_generating_ref: "Generating a reference number...",
    besc_list_notify_duplicating: "ECTN duplication in progress...",
    besc_list_notify_duplicated: "ECTN duplicated successfully!",
    besc_list_notify_initiating: "ECTN initiating in progress...",
    besc_list_notify_initiated: "ECTN successfully sent to GUCE!",
    besc_list_notify_cancelling: "ECTN cancellation in progress...",
    besc_list_notify_cancelled: "ECTN cancelled successfully!",

    besc_list_search_by_besc: "ECTN",

    besc_list_btn_get_reference: "Generate a reference number",
    besc_list_btn_complete_infos: "Complete user informations",
    besc_list_btn_reconciliate_redressing: "Renconciliate Redressings",
    besc_list_btn_reference_list: "List of my reference numbers",
    besc_list_btn_check_bl: "Check a BL number",

    //DIALOG CHECK BL
    besc_list_btn_check_bl_dialog_title: "Check a BL number",
    besc_list_btn_check_bl_dialog_content_text:
      "Enter a BL number to get information on corresponding ECTNs and their statuses",

    //DIALOG Reference List
    besc_list_btn_list_reference_dialog_title: "List of my reference numbers",
    besc_list_btn_list_reference_dialog_content_text:
      "Show list of generated reference numbers",
    besc_list_btn_list_reference_dialog_action_close: "Close",
    besc_list_btn_list_reference_dialog_content_filter_by: "Filter by",
    besc_list_btn_list_reference_dialog_content_filter_all: "All",
    besc_list_btn_list_reference_dialog_content_filter_used: "Used",
    besc_list_btn_list_reference_dialog_content_filter_unused: "Unused",
    besc_list_btn_list_reference_dialog_content_value_used: "USED",
    besc_list_btn_list_reference_dialog_content_value_unused: "UNUSED",
    besc_list_btn_list_reference_dialog_content_reference_number:
      "Reference Number",
    besc_list_btn_list_reference_dialog_content_reference_status: "Status",
    besc_list_btn_list_reference_dialog_content_reference_date: "Creation Date",

    besc_list_tooltip_see: "Show",
    besc_list_tooltip_duplicate: "Duplicate",
    besc_list_tooltip_edit: "Edit",
    besc_list_tooltip_lock: "Lock",
    besc_list_tooltip_unlock: "Unlock",
    besc_list_tooltip_pdf: "Download PDF",
    besc_list_tooltip_validate_redress: "Validate redressing",
    besc_list_tooltip_cancel_redress: "Cancel redressing",
    besc_list_tooltip_cancel_exoneration: "Cancel exoneration'",
    besc_list_tooltip_cancel: "Cancel ECTN",
    besc_list_tooltip_restore: "Reject ECTN Cancellation",
    besc_list_tooltip_exonerate: "Exonerate",
    besc_list_tooltip_deactivate: "Deactivate",
    besc_list_tooltip_activate: "Activate",
    besc_list_tooltip_initiate: "Send to GUCE",
    besc_list_dialog_cancel_title: "ECTN cancellation request",
    besc_list_dialog_cancel_description:
      "Please enter the reason for the cancellation of your ECTN",

    //INTERMEDIAIRE AGREE
    //PAGE TITLE
    page_intermediary_form_title: "Become an intermediary",
    page_intermediary_form_description:
      "Please fill out the form below if you wish to change to the status of intermediary approved by the CNSC",

    //Timeout Modal Dialog
    session_expiration_dialog_header: "Expiration de Session!",
    session_expiration_dialog_body:
      "Your session is about to expire in 10 seconds due to inactivity. You will be redirected to the login page.",
    session_expiration_dialog_action: "Stay Logged In",

    //PAGE CONTENT
    page_intermediary_demand_form: "Demand form",
    page_intermediary_demand_label_coverage_zone_asia: "Asia",
    page_intermediary_demand_label_coverage_zone_middle_orient:
      "Middle Orient & North Africa",
    page_intermediary_demand_label_coverage_zone_subsaharian_africa:
      "Sub-Saharan Africa",
    page_intermediary_demand_label_coverage_zone_europe: "Europe",
    page_intermediary_demand_label_coverage_zone_latin_america: "Latin America",
    page_intermediary_demand_label_coverage_zone_north_america: "North America",
    page_intermediary_demand_label_coverage_zone_oceania: "Oceania",
    page_intermediary_demand_notify_saving_demand: "Saving demand...",
    page_intermediary_demand_card_title_basic_info: "Basic information",
    page_intermediary_demand_label_company_name: "Company name",
    page_intermediary_demand_label_website_url: "Website url",
    page_intermediary_demand_label_years_in_industry:
      "Number of years in industry",
    page_intermediary_demand_card_title_coverage_zone: "Coverage zone",
    page_intermediary_demand_card_title_offices: "Offices",
    page_intermediary_demand_label_office_address: "Address",
    page_intermediary_demand_label_office_rental_contract: "Rental contract",
    page_intermediary_demand_card_title_attachments: "Attachments",
    page_intermediary_demand_label_request_document:
      "Request addressed to the General Manager",
    page_intermediary_demand_label_company_status: "Company statutes",
    page_intermediary_demand_label_engagement_letter:
      "Commitment to respect the operating requirements",
    page_intermediary_demand_label_account_proof:
      "Proof of accounts in a Shippers' Council space",
    page_intermediary_demand_label_worker_cv_one: "Resume of Personnel 1",
    page_intermediary_demand_label_worker_cv_two: "Resume of Personnel 2",
    page_intermediary_demand_label_worker_cv_three: "Resume of Personnel 3",
    page_intermediary_demand_save_demand: "Save request",
    page_intermediary_demand_alert_file_upload_error:
      "Error occurred while uploading file",
    page_intermediary_demand_notify_processing:
      "File processing in progress...",

    //LISTING INTERMEDIAIRES
    page_listing_intermediaries_title: "Approved intermediaries",
    page_listing_intermediaries_description:
      "List of intermediaries approved by the CNSC for the issuance of ECTNs",
    page_listing_intermediaries_headCell_name: "Intermediary name",
    page_listing_intermediaries__headcell_website: "Website",
    page_listing_intermediaries_headcell_offices: "Offices",
    page_listing_intermediaries_headcell_coverage_zone: "Coverage zone",
    page_listing_intermediaries_typo_website_url: "Website URL",
    //TARIFICATION
    page_tarification_title: "Tarification",
    page_tarification_description:
      "The ECTN is paid according to the pricing in force below. It must be",
    page_tarification_description_bold:
      "validated at the latest 48 hours before the arrival of the ship at its destination.",
    page_tarification_headcell_importation: "Importations",
    page_tarification_headcell_exportation: "Exportations",
    page_tarification_headcell_afrique_europe: "Africa and Europe (for one BL)",
    page_tarification_headcell_reste_du_monde: "Rest of the world (for one BL)",
    page_tarification_headcell_afrique: "Africa",
    page_tarification_headcell_reste_du_monde:
      "Europe and the rest of the world",

    //STATISTIQUES BESC
    //PAGE TITLE
    page_statistiques_chargeur_title:
      "Statistics of the different ECTN created in the system",
    page_statistiques_chargeur_description:
      "Information on the different ECTNs created during a specified period",

    page_statistiques_operation_title:
      "Statistics of the different ECTN created in the system",
    page_statistiques_operation_description:
      "Indicators of the different values regarding ECTN delivrance based on specified criteria",

    page_performances_title:
      "Statistics of the different performances of the validation workflow",
    page_performances_description:
      "Indicators of the different numbers of ECTN treated by each role",

    page_reconciliation_title: "ECTN payments audit",
    page_reconciliation_description:
      "Verify the consistency between paid documents and the corresponding financial movements recorded in the billing system",

    //PAGE CONTENT
    page_statistiques_chargeur_label_profile: "Profile",

    //MOUVEMENT BESC
    //PAGE TITLE
    page_mouvement_chargeur_title:
      "Credit movements of the account recorded in the system",
    page_mouvement_chargeur_description:
      "Information on the different debit and credit operations that were done during a specified period",
    page_mouvement_chargeur_label_type: "Operation type",
    page_mouvement_chargeur_label_payment_type: "Payment type",

    page_mouvement_operation_title:
      "Credit movements of the account recorded in the system",
    page_mouvement_operation_description:
      "Information on the different debit and credit operations that were done during a specified period",
    page_mouvement_operation_label_company: "Company Name",

    //PAGE CONTENT
    page_mouvement_chargeur_head_cell_type: "Operation Type",
    page_mouvement_chargeur_head_cell_number: "Number",
    page_mouvement_chargeur_head_cell_number_prefixe: "ECTN",
    page_mouvement_chargeur_head_cell_value: "Value",
    page_mouvement_chargeur_head_cell_ref: "Reference",
    page_mouvement_chargeur_head_cell_ref_prefixe: "Transaction",
    page_mouvement_chargeur_head_cell_paidAt: "Date",
    page_mouvement_chargeur_head_cell_company: "Company",
    page_mouvement_chargeur_label_debit: "Debit",
    page_mouvement_chargeur_label_credit: "Credit",
    page_mouvement_chargeur_label_company_name: "Company name",

    //MY TABLE SEARCH
    my_table_search_label_start_date: "Start Date",
    my_table_search_label_end_date: "End Date",
    my_table_search_label_search_by: "Search By",
    my_table_search_label_created_at: "Created At",
    my_table_search_label_paid_at: "Paid At",
    my_table_search_label_done_at: "Done At",

    besc_list_operation_SL_title: "Liste des BESCs verrouillés",
    besc_list_operation_SL_description:
      "Informations sur les différents BESCs verrouilés",

    //PAGES ERROR BLOCKED
    page_error_blocked_title: "Feature disabled",
    page_error_blocked_description:
      "Creating new ECTNs is not currently available for your account.",
    page_error_blocked_more:
      "Please come back later or contact your support team if you believe this is an error",
    page_error_blocked_btn: "Back to ECTN list",
  },

  ////////////////////////////////////////

  fr: {
    //GENERICS
    alert_file_size:
      "La taille maximale autorisée est de {maxSize} MB, choisissez un fichier moins lourd",
    alert_file_upload_error: "Erreur lors de l'enregistrement du fichier",
    //LANDING PAGE
    landing_page_btn_dashboard: "Dashboard",
    landing_page_btn_connexion_msg: "Se Connecter",
    app_name: "BESC 3.0",
    landing_page_besc_intro:
      "Le Bordereau Electronique de Suivi des Cargaisons, en abregé B.E.S.C, couvre les besoins statistiques, d'identification, de contrôle des coûts de transport, de sûreté et de traçabilité du commerce et du trafic des marchandises en provenance, à destination ou en transit via la République du Cameroun.",
    landing_page_acknowledge_procedures:
      "Bien vouloir prendre connaissance des procédures mises à jour ci-dessous, ou simplement vous rapprocher du CNCC.",
    landing_page_btn_documentation: "Documentation",
    landing_page_btn_costs: "Coûts et tarifs",
    landing_page_btn_intermediary: "Intermédiaires",
    landing_page_stay_connected: "Restez connectés",
    landing_page_follow_us:
      "Suivez nous sur les réseaux sociaux pour découvrir nos prochaines mises à jour.",
    landing_page_newsletter_updates: "Newsletter updates",
    landing_page_newsletter_subscribe:
      "Souscrivez à notre newsletter afin de rester informé des mises à jour sur nos procédures.",
    landing_page_anti_spam:
      "Nous vous promettons de ne pas spammer votre boîte mail. Nous détestons également les spams !",
    landing_page_btn_newsletter_subscribe: "Souscrire",
    landing_page_company_name: "Conseil National des Chargeurs du Cameroun",
    //PAGES REGISTER
    //LOGIN PAGE
    login_page_back_home: "Accueil",
    login_page_title: "Page de Connexion",
    login_page_company: "Conseil National des Chargeurs du Cameroun",
    login_page_activity: "Délivrance du BESC pour le Cameroun",
    login_page_create_account: "Créer un compte",
    login_page_login: "Se connecter",

    //FORGOT PASSWORD PAGE
    forgot_password_page_title: "Récupérer le mot de passe",
    forgot_password_page_description:
      "Entrez votre adresse e-mail et nous le ferons vous envoyer un code de vérification pour réinitialiser votre mot de passe.",
    forgot_password_page_step_label_1: "Réinitialiser le mot de passe",
    forgot_password_page_step_label_2: "Verifier le code",
    forgot_password_page_step_label_else: "Changer le mot de passe",
    forgot_password_page_robot_verification:
      "La vérification du robot est requise.",
    forgot_password_page_email_required: "Addresse mail est requise",
    forgot_password_page_invalid_email: "Addresse mail invalide",
    forgot_password_page_verification_code_required:
      "Code de vérification est requis",
    forgot_password_page_different_passwords:
      "Les deux nouveaux mots de passe sont différents.",
    forgot_password_page_btn_back: "Retour",
    forgot_password_page_placeholder_enter_code:
      "Entrez le code de vérification",
    forgot_password_page_label_password: "Mot de passe",
    forgot_password_page_tooltip_hide_password: "Masquer le mot de passe",
    forgot_password_page_tooltip_show_password: "Afficher le mot de passe",

    forgot_password_page_label_confirm_password: "Confirmer le mot de passe",
    forgot_password_page_btn_resend_code: "Renvoyez le code",
    forgot_password_page_message_attention: "Attention!",
    forgot_password_page_msg_processing: "Traitement en cours...",

    login_page_existing_account: "Compte existant",
    login_page_you_have_account:
      "Vous avez déjà un compte? Veuillez vous connecter à votre espace.",
    login_page_label_email: "Adresse mail",
    login_page_label_password: "Mot de passe",
    login_page_remember_me: "Se souvenir de moi",
    login_page_btn_login: "Se connecter",
    login_page_forgot_password: "Mot de passe oublié?",
    //REGISTER PAGE
    register_page_title: "Page d'Enregistrement",
    register_page_company: "Société",
    register_page_main_account: "Compte Principal",
    register_page_label_country: "Pays",
    register_page_label_niu: "Numéro de Contribuable",
    register_page_label_category: "Catégorie",
    register_page_label_category_person: "Personne Physique",
    register_page_label_category_company: "Entreprise",
    register_page_label_company_name: "Raison Sociale",
    register_page_label_telephone: "Téléphone",
    register_page_label_email: "Adresse mail",
    register_page_label_representative: "Représentant Légal",
    register_page_label_document: "Document NIU",
    register_page_label_document_nic: "Document CNI / Passeport",
    register_page_label_designation_letter_document: "Lettre de désignation",
    register_page_label_nic: "Pièce d'Identité",
    register_page_btn_back: "Précédent",
    register_page_btn_next: "Suivant",
    register_page_btn_create_account: "Créer Un Compte",
    register_page_label_name: "Nom",
    register_page_label_surname: "Prénom",
    register_page_label_main_telephone: "Téléphone",
    register_page_label_main_email: "Adresse mail",
    register_page_label_password: "Mot de passe",
    register_page_label_repeat_password: "Répéter mot de passe",
    register_page_label_password_strength: "Sécurité du mot de passe : ",
    register_page_label_password_requirements:
      "Le mot de passe doit contenir au moins 8 caractères : au moins une minuscule et une majuscule, un caractère spécial et un chiffre",
    register_page_label_password_strength_weak: "Faible",
    register_page_label_password_strength_medium: "Moyenne",
    register_page_label_password_strength_strong: "Forte",
    register_page_typo_accept_conditions:
      "Accepter les conditions d'utilisation",

    register_page_tooltip_download_template: "Télécharger le modèle",

    resgister_page_dialog_terms_title: "Conditions d'utilisation",
    resgister_page_dialog_terms_description:
      "Lisez attentivement les conditions d'utilisation ci-dessous avant de continuer",
    resgister_page_dialog_terms_button_accept: "Accepter",
    resgister_page_dialog_terms_button_close: "Fermer",

    //DASHBOARD SHIPPER
    //PAGE TITLE
    dashboard_shipper_page_title: "Tableau de bord du Chargeur",
    dashboard_shipper_page_description:
      "Vue d'ensemble affichant les différentes statistiques des BESCs crées.",
    //PAGE COMPONENT
    card_title_besc_submitted: "BESCs soumis",
    card_title_besc_processing: "BESCs en cours de traitement",
    card_title_besc_authenticated: "BESCs authentifiés",
    card_title_besc_rejected: "BESCs rejetés",

    //PAGE COMPONENT
    card_title_besc_submitted:
      "{itemCount, plural, =0 { BESC soumis} one { BESC soumis} other { BESCs soumis}}",
    card_title_besc_processing:
      "{itemCount, plural, =0 { BESC en cours de traitement} one { BESC en cours de traitement} other {BESCs en cours de traitement}}",
    card_title_besc_authenticated:
      "{itemCount, plural, =0 { BESC authentifié} one { BESC authentifié} other {BESCs authentifiés}}",
    card_title_besc_rejected:
      "{itemCount, plural, =0 { BESC rejeté} one {BESC rejeté} other {BESCs rejetés}}",

    //BILLING
    //FORMULAIRE MOUVEMENT MANUEL
    //PAGE TITLE
    page_mouvement_manuel_title:
      "Formulaire de débit/crédit manuel d'un compte",
    page_mouvement_manuel_description:
      "Formulaire pour débiter ou créditer un compte manuellement en renseignant les informations et le motif de l'opération",
    //PAGE CONTENT
    page_mouvement_manuel_card_title: "Débiter ou créditer le compte",
    page_mouvement_manuel_card_table_title:
      "Liste des demandes de débit/crédit manuel",
    page_mouvement_manuel_label_explication: "Explication",
    page_mouvement_manuel_dialog_validate_description:
      "Veuillez valider le montant à débiter/créditer sur le compte",

    //FORMULAIRE DEMANDE D'APPROVISIONNEMENT
    //PAGE TITLE
    page_demande_approvisionnement_title:
      "Formulaire de demande d'approvisionnement",
    dialog_demande_approvisionnement_title:
      "Conditions d'approvisionnement du compte de crédit",
    page_demande_approvisionnement_description:
      "Formulaire pour demander à approvisionner un compte en remplissant les informations demandées",
    //PAGE CONTENTs
    page_demande_approvisionnement_funding_terms_error:
      "Veuillez accepter les conditions en tapant OUI avant de pouvoir continuer cette opération.",
    page_demande_approvisionnement_card_response: "Réponse",
    page_demande_approvisionnement_card_validate: "Valider",
    page_demande_approvisionnement_card_title: "Approvisionner le compte",
    page_demande_approvisionnement_label_payment_mode: "Moyen de paiement",
    page_demande_approvisionnement_label_amount: "Montant",
    page_demande_approvisionnement_label_phone: "Numéro",
    page_demande_approvisionnement_label_bank: "Banque",
    page_demande_approvisionnement_btn_submit: "Enregistrer la demande",
    page_demande_approvisionnement_notify_saving:
      "Enregistrement de la demande en cours...",
    page_demande_approvisionnement_notify_success:
      "Approvisionnement initié avec succès, vous pouvez télécharger la proforma pour procéder au paiement et à la validation",
    page_demande_approvisionnement_alert_initiating_momo:
      "Paiement MoMo en cours d'inititation...",
    page_demande_approvisionnement_alert_initiating_om:
      "Paiement OM en cours d'inititation...",
    page_demande_approvisionnement_alert_initiating_axepta:
      "Paiement Afriland en cours d'inititation...",
    page_demande_approvisionnement_helper_tel:
      "Veuillez entrer un numéro de téléphone valide ",
    page_demande_approvisionnement_company_not_found:
      "Informations sur l'entreprise introuvables. Veuillez vous déconnecter et vous reconnecter, puis réessayer cette opération.",
    page_demande_approvisionnement_company_inactive:
      "Compte entreprise non activé. Veuillez contacter l'équipe support!",
    page_demande_approvisionnement_notify_fill_all_fields:
      "Merci de selectionner le moyen de paiement et preciser le montant a approvisionner",
    page_demande_approvisionnement_notify_phone_required:
      "Le numéro de téléphone est requis",
    page_demande_approvisionnement_notify_error_crediting:
      "Une erreur est survenue lors de votre demande d'approvisionnement, veuillez réessayer",

    //LISTING DES REDRESSEMENTS BESC
    //PAGE TITLE
    page_listing_redressement_title:
      "Listing des redressements BESC en attente de paiement",
    page_listing_redressement_description:
      "Tableau affichant les différentes redressements BESC en attente de paiement",

    //LISTING DES DEMANDES D'APPROVISIONNEMENT
    //PAGE TITLE
    page_listing_approvisionnements_title:
      "Listing des approvisionnements effectués par l'utilisateur",
    page_listing_approvisionnements_description:
      "Tableau affichant les différentes demandes d'approvisionnement enregistrées dans le système",

    //TOOLTIPS
    page_listing_approvisionnements_tooltip_clear: "Effacer",
    page_listing_approvisionnements_tooltip_refresh: "Rafraîchir",
    page_listing_approvisionnements_tooltip_download:
      "Télécharger Proforma/Facture",
    page_listing_approvisionnements_tooltip_proof:
      "Télécharger la preuve de paiement",
    page_listing_approvisionnements_tooltip_upload:
      "Joindre la preuve de paiement",
    page_listing_approvisionnements_tooltip_process: "Traiter",
    page_listing_approvisionnements_tooltip_show: "Voir",

    //PAGE CONTENT
    page_listing_approvisionnements_label_search_by: "Recherher par",
    page_listing_approvisionnements_head_cell_reference: "Reférence",
    page_listing_approvisionnements_head_cell_ectn: "BESC",
    page_listing_approvisionnements_head_cell_company: "Société",
    page_listing_approvisionnements_head_cell_amount_requested:
      "Montant Demandé",
    page_listing_approvisionnements_head_cell_date_requested: "Date de Demande",
    page_listing_approvisionnements_head_cell_amount_received: "Montant Reçu",
    page_listing_approvisionnements_head_cell_status: "Statut",
    page_listing_approvisionnements_head_cell_actions: "Actions",
    page_listing_approvisionnements_search_placeholder:
      "Entrez un mot clé à rechercher",
    page_listing_approvisionnements_dialog_validate_title:
      "Traiter la demande d'approvisionnement",
    page_listing_approvisionnements_dialog_validate_description:
      "Veuillez joindre le fichier et valider le montant à créditer sur le compte",
    page_listing_approvisionnements_dialog_pay_title: "Traiter le paiement",
    page_listing_approvisionnements_dialog_pay_description:
      "Veuillez renseigner les informations pour valider le paiement",
    page_listing_approvisionnements_dialog_validate_label_payment_mode:
      "Mode de Paiement",
    page_listing_approvisionnements_dialog_validate_label_payment_bank:
      "Banque de Paiement",
    page_listing_approvisionnements_dialog_validate_label_amount:
      "Montant attendu",
    page_listing_approvisionnements_dialog_validate_label_payment_amount:
      "Montant reçu",
    page_listing_approvisionnements_dialog_validate_label_proof:
      "Preuve de paiement",
    page_listing_approvisionnements_dialog_validate_label_observation:
      "Observation",
    page_listing_approvisionnements_dialog_validate_btn_cancel: "Annuler",
    page_listing_approvisionnements_dialog_validate_btn_reject: "Rejeter",
    page_listing_approvisionnements_dialog_validate_btn_validate: "Valider",
    page_listing_approvisionnements_dialog_validate_btn_pay: "Valider",
    page_listing_approvisionnements_dialog_show_title:
      "Détails de la transaction",
    page_listing_approvisionnements_dialog_show_description: "Statut : ",
    page_listing_approvisionnements_dialog_show_status_approved: "Approuvée",
    page_listing_approvisionnements_dialog_show_status_waiting:
      "En attente de validation",
    page_listing_approvisionnements_dialog_show_status_rejected: "Rejectée",
    page_listing_approvisionnements_dialog_show_label_payment_mode:
      "Mode de Paiement",
    page_listing_approvisionnements_dialog_show_label_amount_requested:
      "Montant demandé",
    page_listing_approvisionnements_dialog_show_label_amount_received:
      "Montant reçu",
    page_listing_approvisionnements_dialog_show_label_amount_debited:
      "Montant débité",
    page_listing_approvisionnements_dialog_show_label_amount_d:
      "Received amount",
    page_listing_approvisionnements_dialog_show_label_date_requested:
      "Date de la demande",
    page_listing_approvisionnements_dialog_show_label_payment_date:
      "Date de paiement",
    page_listing_approvisionnements_dialog_show_label_currency: "Devise",
    page_listing_approvisionnements_dialog_show_label_observation:
      "Observation",
    page_listing_approvisionnements_dialog_show_btn_show_payment_proof:
      "Visualiser preuve de paiement",
    page_listing_approvisionnements_dialog_show_btn_close: "Fermer",

    page_listing_approvisionnements_dialog_attach_title:
      "Joindre la preuve de paiement",
    page_listing_approvisionnements_dialog_attach_description:
      "Veuillez sélectionner le document à joindre, ensuite cliquer sur soumettre",
    page_listing_approvisionnements_dialog_label_file: "Preuve de paiement",
    page_listing_approvisionnements_dialog_button_cancel: "Annuler",
    page_listing_approvisionnements_dialog_button_submit: "Soumettre",

    //HEADER

    //HEADER MENU
    header_menu_home_page: "Page d'Accueil",
    //HEADER DOTS
    header_dots_notifications_title: "Notifications",
    header_dots_notifications_description:
      "{itemCount, plural, =0 {Vous avez n'avez aucune nouvelle notification} one {Vous avez une nouvelle notification} other {Vous avez {itemCount, number} nouvelles notifications}}",
    header_dots_tab_notifications: "Notifications",
    header_dots_tab_notifications_no_message: "Aucun message non lu",
    header_dots_tab_notifications_btn_see_all: "Voir tout",
    header_dots_tab_notifications_btn_mark_as_read: "Marquer comme lu",
    header_dots_tab_history: "Historique",
    header_dots_profile_my_account: "Mon compte",
    header_dots_profile_settings: "Paramètres",
    header_dots_profile_tasks: "Tâches",
    header_dots_profile_balance: "Solde du Compte",
    header_dots_profile_amount_engaged: "Montant engagé",
    header_dots_btn_logout: "Déconnexion",

    //PROFILE PAGE
    //PAGE TITLE
    profile_page_title: "Profil",
    profile_page_content:
      "Vue du profil de l'utilisateur connecté avec possibilité de changer certaines informations",
    //PAGE CONTENT
    profile_page_btn_change_photo: "Changer de photo",
    profile_page_label_sub_accounts: "Sous comptes",
    profile_page_tab_profile_details: "Détails Profil",
    profile_page_tab_profile_details_title: "Détails du compte",
    profile_page_tab_profile_details_label_name: "Nom",
    profile_page_tab_profile_details_label_surname: "Prénom",
    profile_page_tab_profile_details_label_email: "E-mail",
    profile_page_tab_profile_details_label_nic: "CNI",
    profile_page_tab_profile_details_label_function: "Poste",
    profile_page_tab_profile_details_label_phone: "Tel",
    profile_page_tab_profile_details_btn_submit: "Soumettre",
    profile_page_tab_profile_details_btn_processing: "Traitement en cours...",
    profile_page_tab_company_details: "Détails Entreprise",
    profile_page_tab_company_details_title: "Détails de l'entreprise",
    profile_page_tab_company_details_label_company_name: "Raison Sociale",
    profile_page_tab_company_details_label_taxpayer_number:
      "Numéro de contribuable",
    profile_page_tab_company_details_label_currency: "Devise",
    profile_page_tab_company_details_label_country: "Pays",
    profile_page_tab_company_details_label_representative: "Représentant",
    profile_page_tab_company_details_label_phone: "Tel",
    profile_page_tab_company_details_label_email: "E-mail",
    profile_page_tab_company_details_label_language: "Langue Preférée",
    profile_page_tab_company_details_btn_become_intermediary:
      "Devenir un intermédiaire agréé",
    profile_page_tab_company_details_btn_submit: "Soumettre",

    profile_page_tab_security: "Sécurité",
    profile_page_tab_security_title: "Changer le mot de passe",
    profile_page_tab_security_label_password: "Mot de passe",
    profile_page_tab_security_label_new_password: "Nouveau mot de passe",
    profile_page_tab_security_label_confirm_password:
      "Confirmation nouveau mot de passe",
    profile_page_tab_security_btn_submit: "Appliquer",

    profile_page_tab_company_become_intermediary_processing_information:
      "Votre demande pour devenir intermédiaire est en cours de traitement. Vous serez informé par mail du statut de la demande",

    profile_page_alert_success: "Succès",
    profile_page_alert_error: "Erreur",

    //PAGE DE CREATION
    //PAGE TTTLE
    create_besc_maritime_import_page_title_create:
      "Nouveau BESC {sense} Maritime",
    create_besc_maritime_import_page_title_edit:
      "Modification du BESC {number}",
    create_besc_maritime_import_page_description_create:
      "Formulaire de création d'un BESC par remplissage des différents champs",
    create_besc_maritime_import_page_description_edit:
      "Formulaire de modification d'un BESC par mise à jour des différents champs",

    //PAGE CONTENT
    create_besc_has_reference: "Avez-vous un numéro de référence?",
    create_besc_is_grouped: "S'agit-il d'un groupage?",
    create_besc_label_reference: "Numéro de référence",
    create_besc_maritime_import_notify_creating_shipper:
      "Création d'un nouveau chargeur...",
    create_besc_maritime_import_notify_success_shipper:
      "Chargeur ajouté avec succès",
    create_besc_maritime_import_notify_creating_foreign_shipper:
      "Création d'un nouveau fournisseur...",
    create_besc_maritime_import_notify_success_foreign_shipper:
      "Fournisseur ajouté avec succès",
    //SECTION FICHIERS
    create_besc_maritime_import_accordion_files: "Fichiers",
    create_besc_maritime_import_accordion_files_typo_file_type:
      "Type de fichier",
    create_besc_maritime_import_accordion_files_typo_load_file:
      "Charger un fichier",
    create_besc_maritime_import_accordion_files_typo_file_name:
      "Nom du fichier",
    create_besc_maritime_import_accordion_files_select_ref:
      "Document de référence",
    create_besc_maritime_import_accordion_files_select_commercial:
      "Facture Commerciale",
    create_besc_maritime_import_accordion_files_select_fret: "Facture Fret",
    create_besc_maritime_import_accordion_files_select_packing_list:
      "Liste de colisage",
    create_besc_maritime_import_accordion_files_select_packing_certificate:
      "Certificat d'empotage",
    create_besc_maritime_import_accordion_files_select_certificate_origin:
      "Certificat d'Origine",
    create_besc_maritime_import_accordion_files_special_authorization:
      "FIMEX/ASI",
    create_besc_maritime_import_accordion_files_exoneration:
      "Document d'exoneration",
    create_besc_maritime_import_accordion_files_select_vgm: "Certificat VGM",
    create_besc_maritime_import_accordion_files_select_other: "Autre",
    create_besc_maritime_import_accordion_files_btn_add: "Ajouter un fichier",
    create_besc_maritime_import_accordion_files_alert_file_size:
      "La taille maximale autorisée est de 2MB, choisissez un fichier moins lourd",
    create_besc_maritime_import_accordion_files_alert_fill_special_authorization:
      "Veuillez joindre le document FIMEX/ASI pour pouvoir continuer",
    create_besc_maritime_import_accordion_files_alert_fill_packing_certificate:
      "Veuillez joindre le certificat d'empotage pour pouvoir continuer",
    create_besc_maritime_import_accordion_files_alert_fill_vgm:
      "Veuillez joindre le certificat VGM pour pouvoir continuer",

    //SECTION SUIVI
    create_besc_maritime_import_accordion_transaction: "Suivi",
    create_besc_maritime_import_accordion_transaction_title: "Transaction",
    create_besc_maritime_import_accordion_transaction_dialog_title:
      "Ajouter une transaction",
    create_besc_maritime_import_accordion_transaction_dialog_description:
      "Vous avez un numéro de transaction? Entrez-le ici",
    create_besc_maritime_import_accordion_transaction_dialog_label_transaction:
      "Numéro de transaction",
    create_besc_maritime_import_accordion_transaction_dialog_label_taxpayer_number:
      "Numéro de contribuable",
    create_besc_maritime_import_accordion_transaction_dialog_btn_cancel:
      "Annuler",
    create_besc_maritime_import_accordion_transaction_dialog_btn_add: "Ajouter",
    create_besc_maritime_import_accordion_transaction_dialog_notify_searching:
      "Recherche de la transaction en cours",
    create_besc_maritime_import_accordion_transaction_dialog_notify_added:
      "Transaction ajoutée avec succès",
    create_besc_maritime_import_accordion_transaction_dialog_notify_different_shipper:
      "Ce numéro renseigne un chargeur différent de celui renseigné dans le formulaire",
    create_besc_maritime_import_accordion_transaction_dialog_notify_not_found:
      "Transaction Introuvable",
    create_besc_maritime_import_accordion_transaction_dialog_helper_transaction:
      "Ce numéro de transaction est déjà présent",

    //SECTION EXPEDITEUR&DESTINATAIRE
    create_besc_maritime_import_accordion_shippers: "Expéditeur & Destinataire",
    //DESTINATAIRE
    create_besc_maritime_import_accordion_shippers_card_recipient:
      "Destinataire",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_name:
      "Nom ou Raison Sociale",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_taxpayer_number:
      "NIU",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_phone:
      "Téléphone",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_email:
      "E-mail",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_address:
      "Adresse",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_town:
      "Ville",
    create_besc_maritime_import_accordion_shippers_card_recipient_helper_existing_taxpayer_number:
      "Ce NIU existe déjà dans le système",
    create_besc_maritime_import_accordion_shippers_card_recipient_helper_blocked_shipper:
      "La création de BESCs est actuellement désactivée pour cet expéditeur",
    create_besc_maritime_import_accordion_shippers_card_recipient_helper_invalid_phone:
      "Veuillez entrer un numéro de téléphone valide ",
    create_besc_maritime_import_accordion_shippers_card_recipient_helper_invalid_taxpayer_number:
      "Veuillez entrer un numéro de contribuable valide",
    create_besc_maritime_import_accordion_shippers_card_recipient_helper_invalid_email:
      "Veuillez entrer un email valide",
    create_besc_maritime_import_accordion_shippers_card_recipient_label_searching:
      "Recherche en cours...",
    //EXPEDITEUR
    create_besc_maritime_import_accordion_shippers_card_sender: "Expéditeur",
    create_besc_maritime_import_accordion_shippers_card_sender_label_name:
      "Nom ou Raison Sociale",
    create_besc_maritime_import_accordion_shippers_card_sender_label_phone:
      "Téléphone",
    create_besc_maritime_import_accordion_shippers_card_sender_label_email:
      "E-mail",
    create_besc_maritime_import_accordion_shippers_card_sender_label_address:
      "Adresse",
    create_besc_maritime_import_accordion_shippers_card_sender_label_town:
      "Ville",
    create_besc_maritime_import_accordion_shippers_card_sender_helper_invalid_phone:
      "Veuillez entrer un numéro de téléphone valide ",
    create_besc_maritime_import_accordion_shippers_card_sender_helper_invalid_email:
      "Veuillez entrer un email valide",
    create_besc_maritime_import_accordion_shippers_card_sender_label_searching:
      "Recherche en cours...",

    //SECTION CARGAISON
    create_besc_maritime_import_accordion_cargo: "Cargaison",
    create_besc_maritime_import_accordion_cargo_card_cargo: "Marchandise",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning:
      "Type de conditionnement",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_container:
      "Conteneur",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_roro:
      "Ro-ro",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_bulk:
      "Vrac",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_conditionning_conventional:
      "Conventionnel",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_commercial_value:
      "Valeur commerciale",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_commercial_currency:
      "Devise",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_fob_value:
      "Valeur FOB",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_fob_currency:
      "Devise",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product_type:
      "Type de marchandise",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_weight:
      "Poids (Kg)",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_volume:
      "Volume en ",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_twenty:
      "Nb 20''",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_forty:
      "Nb 40''",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_vehicles:
      "Nb vehicules",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_motos:
      "Nb motos",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_sh_code:
      "Codes SH de la marchandise",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_nb_packages:
      "Nb colis",
    create_besc_maritime_import_accordion_cargo_card_cargo_typo_sh_code:
      "Code SH",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product:
      "Nom du Produit",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product_weight:
      "Poids (Kg)",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product_volume:
      "Volume",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product_value:
      "Valeur",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_product_currency:
      "Devise",
    create_besc_maritime_import_accordion_cargo_card_cargo_label_searching:
      "Recherche en cours...",
    //CONTAINER INFORMATION
    create_besc_maritime_import_accordion_cargo_card_container: "Conteneurs",
    create_besc_maritime_import_accordion_cargo_card_container_label_number:
      "Numéro de conteneur",
    create_besc_maritime_import_accordion_cargo_card_container_label_size:
      "Taille",
    create_besc_maritime_import_accordion_cargo_card_container_label_seal:
      "Numéro de plomb",
    create_besc_maritime_import_accordion_cargo_card_container_label_type:
      "Type de conteneur",
    create_besc_maritime_import_accordion_cargo_card_container_label_loading:
      "Chargement",
    create_besc_maritime_import_accordion_cargo_card_container_label_weight:
      "Poids",
    create_besc_maritime_import_accordion_cargo_card_container_label_content:
      "Contenu",
    create_besc_maritime_import_accordion_cargo_card_container_helper_existing_container:
      "Ce numéro de conteneur a déjà été entré",
    create_besc_maritime_import_accordion_cargo_card_container_helper_existing_seal:
      "Ce numéro de plomb a déjà été entré",
    create_besc_maritime_import_accordion_cargo_card_container_helper_invalid_container:
      "Veuillez entrer un numéro de conteneur valide",
    create_besc_maritime_import_accordion_cargo_card_container_download_template:
      "Télécharger le modèle Excel",
    create_besc_maritime_import_accordion_cargo_card_container_import_file:
      "Importer les conteneurs",
    create_besc_maritime_import_accordion_cargo_card_container_import_help:
      "Saisissez les conteneurs manuellement, ou téléchargez le modèle, remplissez-le et importez-le. Le nombre de conteneurs 20' et 40' est compté à partir de la colonne taille.",
    create_besc_maritime_import_accordion_cargo_card_container_import_success:
      "{twenty} conteneur(s) de 20' et {forty} conteneur(s) de 40' importés.",
    create_besc_maritime_import_accordion_cargo_card_container_import_empty:
      "Le fichier ne contient aucun conteneur 20' ou 40'.",
    create_besc_maritime_import_accordion_cargo_card_container_import_invalid:
      "Veuillez choisir un fichier Excel (.xlsx).",
    create_besc_maritime_import_accordion_cargo_card_container_import_error:
      "Le fichier n'a pas pu être lu.",

    //VEHICLE INFORMATION
    create_besc_maritime_import_accordion_cargo_card_vehicle: "Châssis",
    create_besc_maritime_import_accordion_cargo_card_vehicle_label_number:
      "Numéro de châssis",
    create_besc_maritime_import_accordion_cargo_card_vehicle_label_model:
      "Modèle",
    create_besc_maritime_import_accordion_cargo_card_vehicle_label_gray:
      "Carte grise",
    create_besc_maritime_import_accordion_cargo_card_vehicle_label_year:
      "Date de mise en circulation",
    create_besc_maritime_import_accordion_cargo_card_vehicle_label_content:
      "Contenu",
    create_besc_maritime_import_accordion_cargo_card_vehicle_helper_existing_number:
      "Ce numéro de châssis a déjà été entré",
    create_besc_maritime_import_accordion_cargo_card_vehicle_alert_file_size:
      "La taille maximale autorisée est de 1MB, veuillez choisir un fichier moins lourd",

    //SECTION CONTRAT DE TRANSPORT
    create_besc_maritime_import_accordion_transport: "Contrat de transport",
    create_besc_maritime_import_accordion_transport_label_bill_of_lading:
      "Connaissement",
    create_besc_maritime_import_accordion_transport_helper_existing_bl:
      "Ce numéro de connaissement existe déjà dans le système pour un autre BESC, veuillez entrer un autre",
    create_besc_maritime_import_accordion_transport_label_carrier:
      "Transporteur",
    create_besc_maritime_import_accordion_transport_label_vessel: "Navire",
    create_besc_maritime_import_accordion_transport_label_voyage:
      "Numéro de voyage",
    create_besc_maritime_import_accordion_transport_label_date_emb:
      "Date d'embarquement",
    create_besc_maritime_import_accordion_transport_label_eta:
      "Date d'arrivée estimative",
    create_besc_maritime_import_accordion_transport_label_incoterm: "Incoterm",
    create_besc_maritime_import_accordion_transport_label_country_origin:
      "Pays d'Origine",
    create_besc_maritime_import_accordion_transport_label_country_transit:
      "Pays de Transit",
    create_besc_maritime_import_accordion_transport_label_pays_emb:
      "Pays d'embarquement",
    create_besc_maritime_import_accordion_transport_label_port_emb:
      "Port d'embarquement",
    create_besc_maritime_import_accordion_transport_label_port_deb:
      "Port de débarquement",
    create_besc_maritime_import_accordion_transport_label_fret: "Fret",
    create_besc_maritime_import_accordion_transport_label_fret_currency:
      "Devise",
    create_besc_maritime_import_accordion_transport_label_insurance:
      "Assurance",
    create_besc_maritime_import_accordion_transport_label_insurance_currency:
      "Devise",
    create_besc_maritime_import_accordion_transport_label_suppl: "Frais suppl.",
    create_besc_maritime_import_accordion_transport_label_suppl_currency:
      "Devise",
    create_besc_maritime_import_accordion_transport_label_baf: "Baf",
    create_besc_maritime_import_accordion_transport_label_baf_currency:
      "Devise",
    create_besc_maritime_import_accordion_transport_label_caf: "Caf",
    create_besc_maritime_import_accordion_transport_label_caf_currency:
      "Devise",
    create_besc_maritime_import_accordion_transport_label_thc: "Thc",
    create_besc_maritime_import_accordion_transport_label_thc_currency:
      "Devise",
    create_besc_maritime_import_accordion_transport_label_final_dest:
      "Destination finale",
    create_besc_maritime_import_accordion_transport_helper_existing_imo:
      "Ce code IMO existe déjà dans le système, le navire associé est : ",
    create_besc_maritime_import_accordion_transport_notify_adding_vessel:
      "Ajout du navire en cours...",
    create_besc_maritime_import_accordion_transport_notify_vessel_added:
      "Navire ajouté avec succès",
    create_besc_maritime_import_accordion_transport_label_searching:
      "Recherche en cours...",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_title:
      "Ajouter un nouveau navire",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_description:
      "Vous ne retrouvez pas le navire dans la liste? Ajoutez-le ici",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_label_name:
      "Nom du navire",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_label_imo:
      "Code IMO",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_label_mmsi:
      "Code MMSI",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_btn_cancel:
      "Annuler",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_btn_submit:
      "Ajouter",
    create_besc_maritime_import_accordion_transport_dialog_add_vessel_btn_choose:
      "Choisir ce navire",

    //SECTION GROUPAGE
    create_besc_maritime_import_accordion_grouping: "Groupage",
    create_besc_maritime_import_accordion_grouping_label_bl_number:
      "Numéro de sous BL",
    create_besc_maritime_import_accordion_grouping_label_file_name: "Sous BL",

    //BOUTONS
    create_besc_maritime_import_btn_create: "Créer le BESC",
    create_besc_maritime_import_btn_edit: "Modifier le BESC",

    //VISUALISATION
    //PAGE TITLE
    show_besc_page_title: "Visualisation d'un BESC",
    show_besc_page_description: "Affichage des différents détails du BESC",
    //PAGE CONTENT
    show_besc_typo_demand_number: "Numéro de demande",
    show_besc_typo_besc_number: "Numéro de BESC",
    show_besc_typo_status: "Statut",
    show_besc_typo_value: "Valeur",
    show_besc_typo_penalty: "Pénalité pour retard",
    show_besc_typo_submission_date: "Date de soumission",
    show_besc_typo_reject_reason: "BESC rejeté pour le motif suivant : ",
    show_besc_btn_submit: "Soumettre",
    show_besc_btn_edit: "Modifier",
    show_besc_btn_authenticate: "Authentifier",
    show_besc_btn_verify: "Vérifier",
    show_besc_btn_validate: "Valider",
    show_besc_btn_reject: "Rejeter",
    show_besc_btn_pay: "Payer",
    show_besc_btn_pay_redressing: "Payer le redressement",
    show_besc_btn_complete: "Compléter",

    show_besc_notify_paying: "BESC en cours de paiement...",
    show_besc_notify_paying_redressing: "Redressement en cours de paiement...",
    show_besc_notify_paid: "BESC payé avec succès",
    show_besc_notify_paid_redressing: "Redressement payé avec succès",
    show_besc_notify_verifying: "Vérification en cours...",
    show_besc_notify_validating_exoneration: "BESC en cours d'exoneration...",
    show_besc_notify_cancelling_exoneration:
      "Exoneration BESC en cours d'annulation...",
    show_besc_notify_exonerated: "Exonération traitée avec succès",

    show_besc_notify_validating_cancellation: "Annulation du BESC en cours...",
    show_besc_notify_cancelling_cancellation:
      "Rejet de l'annulation du BESC...",
    show_besc_notify_cancelled: "Annulation traitée avec succès",

    show_besc_notify_insufficient_balance:
      "Votre solde est insuffisant, veuillez recharger votre compte",
    show_besc_notify_network_error:
      "Il est possible qu'il y ait un problème de connexion, veuillez réessayer plus tard",

    show_besc_action_submit: "soumission",
    show_besc_action_reject: "rejet",
    show_besc_action_validate: "validation",
    show_besc_action_verify: "vérification",
    show_besc_action_authenticate: "authentification",
    show_besc_notify_action: "BESC en cours de {action}",

    show_besc_tooltip_download_pdf: "Télécharger le PDF",
    show_besc_tooltip_send_notification: "Envoyer une notification",
    show_besc_tooltip_history: "Historique",
    show_besc_tooltip_download: "Télécharger",
    show_besc_tooltip_archive: "Archive",

    show_besc_dialog_authenticate_title: "Authentifier le BESC",
    show_besc_dialog_authenticate_description:
      "Veuillez renseigner la date d'arrivée estimative du navire",
    show_besc_dialog_authenticate_description_export:
      "Veuillez renseigner la date de départ estimative du navire",
    show_besc_dialog_authenticate_label_eta: "Date d'arrivée estimative",
    show_besc_dialog_authenticate_label_etd: "Date de départ estimative",
    show_besc_dialog_authenticate_btn_cancel: "Annuler",
    show_besc_dialog_authenticate_btn_authenticate: " Authentifier",

    show_besc_dialog_complete_title: "Complétez les informations sur le BESC",
    show_besc_dialog_complete_description:
      "Veuillez remplir les informations complémentaires sur ce BESC puis valider pour pouvoir l'imprimer",
    show_besc_dialog_complete_label_niu: "Numéro de contribuable",
    show_besc_dialog_complete_label_file:
      "Fichier d'autorisation spéciale d'importation",
    show_besc_dialog_complete_btn_validate: "Valider",

    show_besc_dialog_history_title: "Changements effectués",
    show_besc_dialog_history_content:
      "Ci-dessous les changements effectués sur le BESC",
    show_besc_dialog_history_btn_close: "Fermer",

    show_besc_dialog_notification_title: "Envoyer une notification",
    show_besc_dialog_notification_description:
      "Veuillez entrer l'objet et le corps du message",
    show_besc_dialog_notification_label_besc: "BESC ",
    show_besc_dialog_notification_label_subject: "Objet",
    show_besc_dialog_notification_label_content: "Contenu",
    show_besc_dialog_notification_btn_cancel: "Annuler",
    show_besc_dialog_notification_btn_send: "Envoyer",

    show_besc_dialog_reject_title: "Rejeter le BESC",
    show_besc_dialog_reject_description:
      "Veuillez renseigner le motif de rejet du BESC",
    show_besc_dialog_reject_label_reason: "Motif",
    show_besc_dialog_reject_btn_cancel: "Annuler",
    show_besc_dialog_reject_btn_send: "Rejeter",

    show_besc_dialog_confirm_submit_title: "Soumission du BESC",
    show_besc_dialog_confirm_submit_description:
      "Êtes vous sûr de vouloir effectuer cette action?",
    show_besc_dialog_confirm_submit_action_cancel: "Annuler",
    show_besc_dialog_confirm_submit_action_confirm: "Soumettre",

    show_besc_typo_code: "Code",
    show_besc_typo_description: "Description",
    show_besc_typo_produit: "Produit",

    //CONFIGURATION
    configuration_typo_add_account: "Ajouter un compte",
    configuration_typo_edit_account: "Modifier un compte",
    configuration_label_name: "Nom",
    configuration_label_surname: "Prénom",
    configuration_label_phone: "Téléphone",
    configuration_label_email: "E-mail",
    configuration_label_function: "Fonction",
    configuration_label_role: "Rôle",
    configuration_btn_save: "Enregistrer",
    configuration_btn_edit: "Modifier",
    configuration_btn_cancel: "Annuler",
    configuration_typo_list: "Liste des comptes",
    configuration_header_name: "Nom",
    configuration_header_surname: "Prénom",
    configuration_header_phone: "Téléphone",
    configuration_header_email: "E-mail",
    configuration_header_role: "Rôle",
    configuration_notify_not_logged:
      "Vous devez être connecté pour effectuer cette action",
    configuration_notify_processing: "Traitement en cours...",
    configuration_notify_error_processing:
      "Erreur lors du traitement des données",
    configuration_notify_error_loading: "Erreur lors du chargement des données",
    configuration_typo_undefined: "Non défini",

    //LISTE BESC

    //PAGE TITLES
    besc_list_my_bescs_title: "Liste des BESCs",
    besc_list_my_bescs_description:
      "Tableau affichant la liste des BESCs enregistrés",
    besc_list_all_bescs_title: "Liste de tous les BESCs de la société",
    besc_list_all_bescs_description:
      "Tableau affichant la liste des BESCs du compte et des sous comptes chargeur",
    besc_list_besc_history_title: "Historique des BESCs {verb}",
    besc_list_besc_history_description:
      "Tableau affichant l'historique des BESCs {verb}",
    besc_list_besc_history_verb_verified: "vérifiés",
    besc_list_besc_history_verb_validated: "validés",
    besc_list_besc_history_verb_authenticated: "authentifiés",
    besc_list_awaiting_redress_title: "Liste des redressements",
    besc_list_awaiting_redress_description:
      "Tableau affichant la liste des BESCs en attente de redressement",
    besc_list_awaiting_exoneration_title: "Liste des exonérations",
    besc_list_awaiting_exoneration_description:
      "Tableau affichant la liste des BESCs en attente d'exonération",
    besc_list_awaiting_cancellation_title: "Liste des demandes d'annulation",
    besc_list_awaiting_cancellation_description:
      "Tableau affichant la liste des BESCs en attente d'annulation",

    //PAGE CONTENT
    besc_list_toggle_text_all: "Tous les BESCs",
    besc_list_toggle_text_my_space: "Mes BESCs",
    besc_list_helper_text_all:
      "Activez cette option pour voir les BESCs vérouillés par vous",
    besc_list_helper_text_my_space:
      "Désactivez cette option pour voir tous les BESCs en attente de traitement",

    besc_list_head_cell_demande: "Demande",
    besc_list_head_cell_etat: "Etat",
    besc_list_head_cell_numero: "Numéro",
    besc_list_head_cell_numero_bl: "Numéro de BL",
    besc_list_head_cell_societe: "Société",
    besc_list_head_cell_valeur: "Valeur",
    besc_list_head_cell_nom: "Profil",
    besc_list_head_cell_conditionnement: "Conditionnement",
    besc_list_head_cell_extra_reference: "Référence",
    besc_list_head_cell_cree: "Créé Le",
    besc_list_head_cell_validated: "Validé Le",
    besc_list_head_cell_paid_at: "Payé Le",
    besc_list_head_cell_provenance: "Provenance",
    besc_list_head_cell_loading: "Date d'Embarquement",
    besc_list_search_by_demande: "Numéro de Demande",
    besc_list_search_by_numero: "Numéro de BESC",
    besc_list_search_by_conditionnement: "Conditionnement",
    besc_list_search_by_cree: "Crée Lé",
    besc_list_search_by_expediteur: "Expéditeur",
    besc_list_search_by_destinataire: "Destinataire",
    besc_list_search_by_bill_of_lading: "Numéro de BL",
    besc_list_search_by_reference_number: "Numéro de Référence",
    besc_list_search_by_container_number: "Numéro de Conteneur",
    besc_list_search_by_chassis_number: "Numéro de Chassis",
    besc_list_notify_generating_ref:
      "Génération d'un numéro de référence en cours...",
    besc_list_notify_duplicating: "Duplication du BESC en cours...",
    besc_list_notify_duplicated: "BESC dupliqué avec succès!",
    besc_list_notify_initiating: "Initiation du BESC en cours...",
    besc_list_notify_initiated: "BESC envoyé au GUCE avec succès!",
    besc_list_notify_cancelling: "Annulation du BESC en cours...",
    besc_list_notify_cancelled: "Annulation effectuée avec succès",

    besc_list_search_by_besc: "BESC",

    besc_list_btn_get_reference: "Obtenir un numéro de référence",
    besc_list_btn_complete_infos: "Compléter les informations",
    besc_list_btn_reconciliate_redressing: "Renconcilier les redressements",
    besc_list_btn_reference_list: "Liste des numéros de référence",
    besc_list_btn_check_bl: "Vérifier un numéro de BL",

    //DIALOG CHECK BL
    besc_list_btn_check_bl_dialog_title: "Vérifier un numéro de BL",
    besc_list_btn_check_bl_dialog_content_text:
      "Entrez un numéro de BL pour obtenir des BESCs correspondants avec leur statuts",

    //DIALOG Reference List
    besc_list_btn_list_reference_dialog_title: "Liste des numéros de référence",
    besc_list_btn_list_reference_dialog_content_text:
      "Consultez ci-dessous la liste des numéros de référence que vous avez eu à générer",
    besc_list_btn_list_reference_dialog_action_close: "Fermer",
    besc_list_btn_list_reference_dialog_content_filter_by: "Filtrer par",
    besc_list_btn_list_reference_dialog_content_filter_all: "Toutes",
    besc_list_btn_list_reference_dialog_content_filter_used: "Utilisées",
    besc_list_btn_list_reference_dialog_content_filter_unused: "Non-utilisées",
    besc_list_btn_list_reference_dialog_content_value_used: "UTILISEE",
    besc_list_btn_list_reference_dialog_content_value_unused: "NON UTILISEE",
    besc_list_btn_list_reference_dialog_content_reference_number:
      "Numéro de référence",
    besc_list_btn_list_reference_dialog_content_reference_status: "Statut",
    besc_list_btn_list_reference_dialog_content_reference_date: "Créé le",

    besc_list_tooltip_see: "Voir",
    besc_list_tooltip_duplicate: "Dupliquer",
    besc_list_tooltip_edit: "Modifier",
    besc_list_tooltip_lock: "Vérouiller",
    besc_list_tooltip_unlock: "Dévérouiller",
    besc_list_tooltip_pdf: "Télécharger le PDF",
    besc_list_tooltip_validate_redress: "Envoyer à la caisse",
    besc_list_tooltip_cancel_redress: "Annuler le redressement",
    besc_list_tooltip_cancel_exoneration: "Annuler l'exonération",
    besc_list_tooltip_cancel: "Annuler le BESC",
    besc_list_tooltip_restore: "Rejeter l'annulation du BESC",
    besc_list_tooltip_exonerate: "Exonérer",
    besc_list_tooltip_deactivate: "Désactiver",
    besc_list_tooltip_activate: "Activer",
    besc_list_tooltip_initiate: "Envoyer au GUCE",

    besc_list_dialog_cancel_title: "Demande d'annulation du BESC",
    besc_list_dialog_cancel_description:
      "Veuillez renseigner le motif de l'annulation du BESC",

    //INTERMEDIAIRE AGREE
    //PAGE TITLE
    page_intermediary_form_title: "Devenir un intermédiaire agréé",
    page_intermediary_form_description:
      "Veuillez remplir le formulaire si dessous vous souhaitez passer au statut d'intermédaire agréé par le CNCC",

    //Timeout Modal Dialog
    session_expiration_dialog_header: "Expiration de Session!",
    session_expiration_dialog_body:
      "Your session is about to expire in 10 seconds due to inactivity. You will be redirected to the login page.",
    session_expiration_dialog_action: "Stay Logged In",

    //PAGE CONTENT
    page_intermediary_demand_form: "Formulaire de demande",
    page_intermediary_demand_label_coverage_zone_asia: "Asie",
    page_intermediary_demand_label_coverage_zone_middle_orient:
      "Moyen Orient & Afrique du Nord",
    page_intermediary_demand_label_coverage_zone_subsaharian_africa:
      "Afrique subsaharienne",
    page_intermediary_demand_label_coverage_zone_europe: "Europe",
    page_intermediary_demand_label_coverage_zone_latin_america:
      "Amérique Latine",
    page_intermediary_demand_label_coverage_zone_north_america:
      "Amérique du Nord",
    page_intermediary_demand_label_coverage_zone_oceania: "Océanie",
    page_intermediary_demand_notify_saving_demand:
      "Enregistrement de la demande en cours...",
    page_intermediary_demand_card_title_basic_info: "Informations de base",
    page_intermediary_demand_label_company_name: "Nom de la société",
    page_intermediary_demand_label_website_url: "Lien du site web",
    page_intermediary_demand_label_years_in_industry: "Années dans l'industrie",
    page_intermediary_demand_card_title_coverage_zone: "Zone de couverture",
    page_intermediary_demand_card_title_offices: "Bureaux",
    page_intermediary_demand_label_office_address: "Adresse",
    page_intermediary_demand_label_office_rental_contract:
      "Document de bail ou de localisation",
    page_intermediary_demand_card_title_attachments: "Pièces jointes",
    page_intermediary_demand_label_request_document:
      "Demande adressée au directeur général",
    page_intermediary_demand_label_company_status: "Statuts de la société",
    page_intermediary_demand_label_engagement_letter:
      "Engagement sur l’honneur à respecter les exigences d’exploitation",
    page_intermediary_demand_label_account_proof:
      "Preuve de comptes dans un espace de Conseil des Chargeurs",
    page_intermediary_demand_label_worker_cv_one: "CV Personnel 1",
    page_intermediary_demand_label_worker_cv_two: "CV Personnel 2",
    page_intermediary_demand_label_worker_cv_three: "CV Personnel 3",
    page_intermediary_demand_save_demand: "Enregistrer la demande",
    page_intermediary_demand_alert_file_upload_error:
      "Erreur lors d'enregistrement du fichier",
    page_intermediary_demand_notify_processing:
      "Traitement du fichier en cours...",

    //LISTING INTERMEDIAIRES
    page_listing_intermediaries_title: "Intermédiaires agréés",
    page_listing_intermediaries_description:
      "Liste des intermédiaires agréés par le CNCC pour l'émission des BESCs",
    page_listing_intermediaries_headCell_name: "Nom de L’intermédiaire",
    page_listing_intermediaries__headcell_website: "Site Web",
    page_listing_intermediaries_headcell_offices: "Bureaux",
    page_listing_intermediaries_headcell_coverage_zone: "Zone de couverture",
    page_listing_intermediaries_typo_website_url: "Lien du site web",

    //TARIFICATION
    page_tarification_title: "Tarification",
    page_tarification_description:
      "Le BESC est acquitté selon la tarification en vigueur ci-dessous. Il doit impérativement être ",
    page_tarification_description_bold:
      "validé au plus tard 48 heures avant l´arrivée du navire à destination.",
    page_tarification_headcell_importation: "Importations",
    page_tarification_headcell_exportation: "Exportations",
    page_tarification_headcell_afrique_europe: "Afrique et Europe (pour un BL)",
    page_tarification_headcell_reste_du_monde: "Reste du monde (pour un BL)",
    page_tarification_headcell_afrique: "Afrique",
    page_tarification_headcell_reste_du_monde: "Europe et reste du monde",

    //STATISTIQUES BESC
    //PAGE TITLE
    page_statistiques_chargeur_title:
      "Statistiques des différents BESCs crées sur la plateforme",
    page_statistiques_chargeur_description:
      "Informations sur les statistiques des BESCs crées sur une période",

    page_statistiques_operation_title:
      "Statistiques des différents BESCs crées sur la plateforme",
    page_statistiques_operation_description:
      "Indicateurs des nombres de BESCs crées sur la pateforme suivant des critères bien définis",

    page_performances_title:
      "Statistiques sur les différentes performances pour le workflow de validation",
    page_performances_description:
      "Indicateurs des différents nombres de BESCs traités par chaque rôle",

    page_reconciliation_title: "Audit des paiements BESC",
    page_reconciliation_description:
      "Vérification de la cohérence entre les paiements BESC enregistrés et les mouvements comptables associés en facturation.",

    //PAGE CONTENT
    page_statistiques_chargeur_label_profile: "Profil",

    //MOUVEMENT BESC
    //PAGE TITLE
    page_mouvement_chargeur_title:
      "Mouvements crédit enregistrés dans le système",
    page_mouvement_chargeur_description:
      "Liste des différentes opérations de débit/crédit associés au compte durant la période définie",
    page_mouvement_chargeur_label_type: "Type d'opération",
    page_mouvement_chargeur_label_payment_type: "Type de paiement",

    page_mouvement_operation_title:
      "Mouvements crédit enregistrés dans le système",
    page_mouvement_operation_description:
      "Liste des différentes opérations de débit/crédit associés au compte durant la période définie",
    page_mouvement_operation_label_company: "Raison sociale",

    //PAGE CONTENT
    page_mouvement_chargeur_head_cell_type: "Type d'Opération",
    page_mouvement_chargeur_head_cell_number: "BESC",
    page_mouvement_chargeur_head_cell_number_prefixe: "Référence",
    page_mouvement_chargeur_head_cell_value: "Valeur",
    page_mouvement_chargeur_head_cell_ref: "Transaction",
    page_mouvement_chargeur_head_cell_ref_prefixe: "Référence",
    page_mouvement_chargeur_head_cell_paidAt: "Date",
    page_mouvement_chargeur_head_cell_company: "Société",
    page_mouvement_chargeur_label_debit: "Débit",
    page_mouvement_chargeur_label_credit: "Crédit",
    page_mouvement_chargeur_label_company_name: "Nom de la société",

    //MY TABLE SEARCH
    my_table_search_label_start_date: "Date de début",
    my_table_search_label_end_date: "Date de fin",
    my_table_search_label_search_by: "Rechercher par",
    my_table_search_label_created_at: "Créé Le",
    my_table_search_label_paid_at: "Payé Le",
    my_table_search_label_done_at: "Effectué Le",

    besc_list_operation_SL_title: "Liste des BESCs verrouillés",
    besc_list_operation_SL_description:
      "Informations sur les différents BESCs verrouilés",

    //PAGES ERROR BLOCKED
    page_error_blocked_title: " Fonctionnalité désactivée",
    page_error_blocked_description:
      "  La création de nouveaux BESCS n'est pas disponible actuellement pour votre compte.",
    page_error_blocked_more:
      " Revenez plus tard ou contactez votre service de support si vous pensez qu'il s'agit d'une erreur",
    page_error_blocked_btn: "Retour à la liste des BESCs",
  },
};

export { statusPerms, actionPerms, cameroon, portsCamer, messages };

//FAIRE PLUTOT DEUX MATRICES  DE VALIDITE
